'use strict';
/* global pageContext */

var customLink = 'custom_link';
var dataLayer = window.dataLayer;
var isPaymentElementVisible = false;
var customerType = $('#checkout-main').attr('data-customer-type');
var isAppSession = false;
if ($('#app-session').length > 0) {
    isAppSession = $('#app-session').val();
}
var customError = 'custom_error';
/**
 * get cookie by name
 * @param {string} name - Cookie name
 * @return {string} - Cookie value
 */
function getCookie(name) {
    var value = ';' + document.cookie + ';';
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
        return (parts[1]).substr(0, parts[1].indexOf(';')).replace(/"/g, '');
    }
    return null;
}

/**
 * Triggers an event to react native app.
 * @param {string} data - details
 */
function postMessageToRN(data) {
    try {
        window.webkit.messageHandlers.ReactNativeWebView.postMessage(data);
    } catch (webkiterror) {
        try {
            window.ReactNativeWebView.postMessage(data);
        } catch (error) {
            console.log(error);
        }
    }
}

/**
 * pass account navigation user to GTM
 * @param {Object} details details data about the event
 * @param {string} event event name
 */
function dataToReactNative(details, event) {
    var json = {
        message: 'callFBEvent',
        eventDetails: details,
        event: event
    };
    postMessageToRN(JSON.stringify(json));
}

/**
 * pass Trade Analytics data
 * @param {string} event event name
 * @param {string} component component name
 * @param {Object} detail details data about the event
 * @param {Object} itemDetails itemDetails data
 */
function tradeProductData(event, component, detail, itemDetails) {
    var details = {
        component: component,
        details: detail,
        source: window.pageContext.ns
    };
    if (itemDetails) {
        details = Object.assign(details, itemDetails);
    }
    dataToReactNative(details, event);
}

/**
 * @param {Object} product product object
 * @param {string|number} quantity product quantity
 * @returns {Object} - json object
 */
function populateProductItem(product, quantity) {
    var item;
    item = {
        item_id: product.productInfo.productID,
        item_name: product.productInfo.name,
        item_category: product.productInfo.category,
        item_variant: product.productInfo.variant,
        item_brand: product.productInfo.brand,
        item_sku: product.productInfo.sku,
        item_condition: product.productInfo.condition,
        item_product_availability: product.productInfo.availability,
        item_genre: product.productInfo.genre,
        item_platform: product.productInfo.platform,
        warranty_id: product.productInfo.warranty_id ? product.productInfo.warranty_id : '',
        warranty_name: product.productInfo.warranty_name ? product.productInfo.warranty_name : '',
        warranty_price: product.productInfo.warranty_price ? product.productInfo.warranty_price : '',
        warranty_quantity: product.productInfo.warranty_quantity ? product.productInfo.warranty_quantity : '',
        item_shipping_method: product.productInfo.item_shipping_method ? product.productInfo.item_shipping_method : '',
        item_shipping_sdd_type: product.productInfo.item_shipping_sdd_type ? product.productInfo.item_shipping_sdd_type : '',
        item_shipping_sdd_availability: product.productInfo.item_shipping_sdd_availability ? product.productInfo.item_shipping_sdd_availability : ''
    };

    if (isAppSession === 'true') {
        if (window.pageContext.ns === 'trade search' || window.pageContext.ns === 'trade details' || window.pageContext.ns === 'Trade') {
            item.item_subgenre = product.productInfo.subGenre;
        } else {
            item.item_base_price = product.price.basePrice;
            item.price = product.price.sellingPrice;
            item.quantity = quantity;
        }
    }
    return item;
}


/**
 * returns component Name using the zoneSource (Analytics)
 * @param {string} zoneSource - zoneSource for addToCart from Recommendation section
 * @return {string} - returns componentName
 */
function returnListNameValue(zoneSource) {
    switch (zoneSource) {
        case 'PDP ATC Modal': return 'PDP Add to Cart Modal';
        case 'console Landing':
        case 'Sales Landing':
        case 'Franchise Landing': return 'Landing Page';
        default: return (window.pageContext.pageType).toUpperCase();
    }
}

/**
 * @param {Object} productObject The product data
 * @param {string} position position in the list
 * @param {string} listItemType list type
 * @param {string} curatedFlag curated flag
 * @description gets the data for a product click
 */
function productClick(productObject, position, listItemType, curatedFlag) {
    position = position || 1; // eslint-disable-line no-param-reassign
    listItemType = listItemType || 'Product list'; // eslint-disable-line no-param-reassign
    productObject.itemPosition = position; // eslint-disable-line no-param-reassign
    var componentType = $('.google-recommendation').attr('data-component-name') || '';
    var obj;
    if (componentType !== '') {
        obj = {
            event: 'Listing Item Clicked',
            componentType: componentType,
            listing: {
                listingResults: {
                    itemListType: listItemType,
                    item: []
                }
            }
        };
    } else {
        obj = {
            event: 'Listing Item Clicked',
            listing: {
                listingResults: {
                    itemListType: listItemType,
                    item: []
                }
            }
        };
    }
    obj.listing.listingResults.item.push(productObject);
    if (curatedFlag) {
        var listNameVal = returnListNameValue(productObject.productInfo.zoneSource);
        var ItemType = listNameVal + ' | Curated Promotions';
        obj.listing.listingResults.itemListType = ItemType;
    }
    dataLayer.push(obj);
    if (isAppSession === 'true' && window.pageContext.ns === 'trade search') {
        var event = 'tradein_product_click';
        var itemDetails = populateProductItem(productObject);

        tradeProductData(event, 'Trade In: Search Results', productObject.productInfo.name, itemDetails);
    }
}

/**
 * @param {Object} productObject product object
 * @param {string} experienceType CTA state
 * @returns {Object} - json object
 */
function populateProductCustomDimension(productObject, experienceType) {
    var returnExperienceType = productObject && productObject.experienceType;
    if (experienceType) {
        returnExperienceType = experienceType;
    }
    return {
        gtmContainerId: $('#googleTagManagerIdNew').val(),
        searchInput: productObject && productObject.searchInput,
        productSKU: productObject && productObject.id,
        searchAutocompleteCategory: productObject && productObject.searchAutocompleteCategory,
        searchAutocompleteValue: productObject && productObject.searchAutocompleteValue,
        cartValue: productObject && productObject.miniCartSubTotal,
        componentType: productObject && productObject.componentType,
        experienceType: returnExperienceType,
        filterType: productObject && productObject.filterType,
        filterValue: productObject && productObject.filterValue,
        persistentSignIn: productObject && productObject.persistentSignIn,
        storeId: productObject && productObject.storeId,
        memberTier: productObject && productObject.memberTier,
        authenticationState: productObject && productObject.authenticationState,
        paymentType: productObject && productObject.paymentType,
        reviewsRating: productObject && productObject.reviewsRating,
        reviewsNumber: productObject && productObject.reviewsNumber
    };
}

/**
 * @param {Object} productObject product object
 * @returns {Object} - json object
 */
function populateProductCustomMetrics(productObject) {
    return {
        orderDiscount: productObject && productObject.orderDiscount,
        eventValue: productObject && productObject.eventValue
    };
}

/**
 * @param {Object} productObject The product data
 * @param {string} listItemType list type
 * @param {string} eventLabel event label
 * @param {string} eventAction event action
 * @param {Object} customDimensions for customDimensions
 * @description gets the data for a product click
 */
function productClicked(productObject, listItemType, eventLabel, eventAction, customDimensions) {
    var componentType = $('.google-recommendation').attr('data-component-name') || '';
    var productObj = {
        id: productObject.id,
        componentType: componentType
    };
    if (customDimensions) {
        productObj.searchInput = customDimensions.queryData;
        productObj.searchAutocompleteValue = customDimensions.suggestResult;
        productObj.experienceType = customDimensions.experienceType;
    }
    var customDimension = populateProductCustomDimension(productObj);
    dataLayer.push({
        event: 'analyticsEvent',
        eventCategory: 'ecommerce',
        eventAction: eventAction,
        eventLabel: eventLabel,
        ecommerce: {
            click: {
                actionField: {
                    list: listItemType
                },
                products: [productObject]
            }
        },
        customDimensions: customDimension,
        customMetrics: populateProductCustomMetrics(productObj)
    });
}

/**
 * @param {string} eventLabel event label
 * @param {string} id for id
 * @param {string} name for name
 * @param {string} creative for creative
 * @param {integer} position for position
 * @description gets the data for a promo click
 */
function promoClicked(eventLabel, id, name, creative, position) {
    dataLayer.push({
        event: 'analyticsEvent',
        eventCategory: 'ecommerce',
        eventAction: 'promotion clicked',
        eventLabel: eventLabel,
        ecommerce: {
            promoClick: {
                promotions: [{
                    id: id,
                    name: name,
                    creative: creative,
                    position: position
                }]
            }
        },
        customDimensions: populateProductCustomDimension({}),
        customMetrics: populateProductCustomMetrics({})
    });
}

/**
 * pass account navigation user to GTM
 * @param {string} linkReg for linkRegion
 * @param {string} linkCat for linkCategories
 *
 */
function accountNavigation(linkReg, linkCat) {
    dataLayer.push({
        linkInfo: {
            linkRegion: linkReg,
            linkCategories: linkCat
        },
        event: 'Navigation Link Clicked'
    });
}
/**
 * pass API Errors to GTM
 * @param {string} errorType for errorType
 * @param {string} errorMessage for errorMessage
 *
 */
function apiErrorForLoyalty(errorType, errorMessage) {
    dataLayer.push({
        errorDetails: {
            errorTrigger: 'API Error',
            errorType: errorType,
            errorMessage: errorMessage,
            errorCategory: 'loyalty'
        },
        event: 'Error Occurrence'
    });
}

/**
 * @description user clicks on Edit Payment link
 */
$(document).on('click', '.editPaymentLink', function () {
    var paymentType = $(this).data('payment-type') && $(this).data('payment-type').toString();
    dataLayer.push({
        eventDetails: {
            eventAction: 'payment Initiate',
            paymentType: paymentType
        },
        event: 'Edit Payment'
    });
});

/**
 * @description user clicks on Save Changes link on edit order page
 */
$(document).on('click', '.updatePaymentLink', function () {
    var paymentType = $(this).data('payment-type') && $(this).data('payment-type').toString();
    dataLayer.push({
        eventDetails: {
            eventAction: 'payment updated',
            paymentType: paymentType
        },
        event: 'Edit Payment'
    });
});

$('.account-nav a').on('click', function (e) {
    var navLink = e.target && e.target.innerText;
    accountNavigation('Account|Left Nav', 'PUR:' + navLink);
});

$(document).on('click', '.header-account-loyalty .header-account-loyalty-links .item-link', function (e) {
    var navLink = e.target && e.target.innerText;
    accountNavigation('Account|slide in', 'PUR:' + navLink);
});

$(document).on('click', '.rewards-grid-header .view-all-link', function () {
    accountNavigation('Account|Dashboard', 'PUR:Rewards Center:View All');
});

$(document).on('API-Error', function (eventName, value) {
    var errMsg = value && value.responseJSON && value.responseJSON.error && value.responseJSON.error.errorText;
    var errType = value && value.responseJSON && value.responseJSON.action;
    apiErrorForLoyalty(errType, errMsg);
});

$(document).on('points:error', function () {
    apiErrorForLoyalty('Points Error', 'There was a problem updating your points preference. Please try again later.');
});

$(document).on('cart-promo-applied:loyaltyerror', function (eventName, data) {
    var errMessage = data && data.errorMessage;
    dataLayer.push({
        eventDetails: {
            eventCategory: 'Powerup Rewards',
            eventAction: 'Reward Center|Apply to cart|Error',
            eventLabel: errMessage
        },
        event: 'Powerup Rewards'
    });
});

$(document).on('Loyalty:RewardsPurchaseSuccess', function () {
    var categoryType = $('#get-it-now').data('attr') && $('#get-it-now').data('attr').toString();
    var isSuccessRedeemed = $('#isRewardsSuccess').val();
    if (isSuccessRedeemed) {
        dataLayer.push({
            eventDetails: {
                eventCategory: 'Powerup Rewards funnel',
                eventAction: 'Reward Center|Purchase Successful',
                eventLabel: categoryType,
                redeemedLoyalty: '1'
            },
            event: 'Powerup Rewards'
        });
    }
});

$(document).on('savechanges:birthday', function () {
    var fromBirthdayLink = $('#save-personal-profile').data('frombirthdaylink') && $('#save-personal-profile').data('frombirthdaylink').toString();
    if (fromBirthdayLink) {
        dataLayer.push({
            eventDetails: {
                eventCategory: 'Powerup Rewards',
                eventAction: 'Save Personal Data',
                eventLabel: 'Birthday Saved'
            },
            event: 'Powerup Rewards'
        });
    }
});

$(document).on('rewardsRedeemCTA:click', function () {
    dataLayer.push({
        eventDetails: {
            eventAction: 'Account|Rewards',
            eventLabel: 'Redeem Points CTA'
        },
        event: 'Site Interaction'
    });
});

$(document).on('rewardsShopNowCTA:click', function () {
    dataLayer.push({
        eventDetails: {
            eventAction: 'Account|Rewards',
            eventLabel: 'Shop Now'
        },
        event: 'Site Interaction'
    });
});

$(document).on('rewardsJoinProCTA:click', function () {
    dataLayer.push({
        eventDetails: {
            eventAction: 'Account|Rewards',
            eventLabel: 'Join Pro'
        },
        event: 'Site Interaction'
    });
});

/**
 * @description user clicks on Confirm during canceling an order
 */
$(document).on('WIS:cancelTradeInOrder', function (e, queryString) {
    var storeId = $('.sub-nav-store-info').attr('data-preferred-store-id');
    dataLayer.push({
        ecommerce: {
            refund: {
                actionField: {
                    id: queryString.split('=')[1],
                    orderType: 'wis',
                    wisStoreID: storeId
                }
            }
        },
        event: 'CancelOrder'
    });
});

/**
 * @description When a user checks/unChecks trade-in acknowledgement
 */
$(document).on('PDP:TradeInAcknowledgement', function (e, isChecked) {
    dataLayer.push({
        eventDetails: {
            eventAction: 'Trade in acknowledgment|PDP',
            eventLabel: isChecked
        },
        event: 'Site Interaction'
    });
});

/**
 * @description When a user clicks on how it works CTA under trade-in
 */
$(document).on('PDP:TradeInHowItWorks', function () {
    dataLayer.push({
        eventDetails: {
            eventAction: 'Trade in|PDP',
            eventLabel: 'How it works'
        },
        event: 'Site Interaction'
    });
});


/**
 * @param {string} errorCode
 * @description error tracking during canceling an order
 */
$(document).on('order:trackOrderCancelError', function (e, errorCode) {
    dataLayer.push({
        eventDetails: {
            errorTrigger: 'API Error',
            errorType: 'Order Cancellation',
            errorCode: errorCode,
            errorCategory: 'ecommerce'
        },
        event: 'Error Occurrence'
    });

    if (isAppSession === 'true') {
        dataToReactNative({
            eventCategory: 'order details',
            eventAction: 'error encountered',
            eventLabel: errorCode
        }, 'analyticsEvent');
    }
});

$(document).on('loyaltyPoints:save', function (event, eventValue) {
    var label = $('form.points-preferences-form [for=' + eventValue + ']');
    if (label && label[0] && label[0].innerText) {
        dataLayer.push({
            eventDetails: {
                eventCategory: 'Powerup Rewards',
                eventAction: 'Save Manage points preference',
                eventLabel: label[0].innerText
            },
            event: 'Powerup Rewards'
        });
    }
});

/**
 * @param {string} clickedPageLink
 * @description When user selects page number or right/left carets to jump through the order History pages
 */
$(document).on('orderHistory:pagination', function (e, clickedPageLink) {
    dataLayer.push({
        eventDetails: {
            eventAction: 'Order Details| Pagination click',
            eventLabel: clickedPageLink
        },
        event: 'Site Interaction'
    });
});

/**
 * @param {string} clickedCtaEventLabel
 * @description When the user selects “COMPLETE ORDER“  or "CONTINUE SHOPPING" on an empty order history page
 */
$(document).on('orderHistory:emptyOrder', function (e, clickedCtaEventLabel) {
    dataLayer.push({
        eventDetails: {
            eventAction: 'Order History| Empty Order',
            eventLabel: clickedCtaEventLabel
        },
        event: 'Site Interaction'
    });

    if (isAppSession === 'true') {
        dataToReactNative({
            eventCategory: 'order history',
            eventAction: 'button clicked',
            eventLabel: clickedCtaEventLabel
        }, 'analyticsEvent');
    }
});

/**
 * @param {string} clickedCtaEventLabel
 * @description When user selects "ORDER DETAILS" on the order history page
 */
$(document).on('orderHistory:orderDetails', function () {
    if (isAppSession === 'true') {
        dataToReactNative({
            eventCategory: 'order history',
            eventAction: 'link clicked',
            eventLabel: 'order details'
        }, 'analyticsEvent');
    }
});

/**
 * @param {string} clickedCtaEventLabel
 * @description When user selects tracking order number link on the order history page
 */
$(document).on('orderHistory:trackOrder', function () {
    if (isAppSession === 'true') {
        dataToReactNative({
            eventCategory: 'order history',
            eventAction: 'link clicked',
            eventLabel: 'track order'
        }, 'analyticsEvent');
    }
});

/**
 * @param {string} dashboard-nav-link link on left navigation pannel
 * @description gets the href link from the left navigation pannel
 */
$(document).on('click', '.dashboard-nav-link', function () {
    accountNavigation('Account Navigation Panel', 'Account');
});

/**
 * @param {string} help-phone-number link on customer care number
 * @description gets the href link from the customer care number
 */
$(document).on('click', '.customer-care-dial', function () {
    var label = 'Account Navigation Panel';
    if ($(this).parents('.customer-care-banner').length) {
        label = 'Account Footer';
    }
    accountNavigation(label, 'Customer Care Dial');
});

/**
 * @param {string} change-setting link on account page top panel
 * @description gets the href link from account page top panel, when user clicks on Stock Pile Change setting
 */
$(document).on('click', '.membership-progress-chart .member-tile-link', function () {
    accountNavigation('Account Powerup Rewards Panel', 'Account');
});

/**
 * @param {string} Show My Benefits link on account page
 * @description gets the link info from account page , when user clicks on Show My benefits link
 */
$(document).on('click', '.membership-progress-chart .showMyBenefitsLink', function () {
    accountNavigation('Account Powerup Rewards Panel', 'Show My benefits');
});

/**
 * @param {string} How do I earn Points link on account page
 * @description gets the link info from account page, when user clicks on How do I earn Points link
 */
$(document).on('click', '.membership-progress-chart .howToEarnPointsLink', function () {
    accountNavigation('Account Powerup Rewards Panel', 'How do I earn Points');
});

/**
 * @param {string} write a review on account page my orders section
 * @description gets the link info from account page top panel, when user clicks on Write a Review link
 */
$(document).on('click', '.dashboard-order #WAR', function () {
    accountNavigation('Account My Orders', 'Write a Review');
});

/**
 * @param {string} rewards center carousel on account page
 * @description gets the link info from account page top panel, when user clicks on Rewards Center
 */
$(document).on('click', '.reward-center-link', function () {
    var category = $(this).data('points') && $(this).data('points').toString();
    accountNavigation('Account Dashboard Reward Certificates', category);
});

// When use clicks on Set up auto Renew on Order Confirmation Page.
$(document).on('click', '.pro-auto-renew-btn', function () {
    dataLayer.push({
        eventDetails: {
            eventAction: 'Pro Auto Renewal Initiation',
            eventLabel: 'Order Confirmation Page'
        },
        event: 'Power Up Rewards'
    });
});

/**
 * @param {Object} product product object
 * @param {string|number} quantity product quantity
 * @param {string} event name of analytics event
 * @returns {Object} - json object
 */
function populateProductTempItem(product, quantity, event) {
    var item = product.productInfo.productID + ',' + product.productInfo.sku + ',' + product.productInfo.variant + ',' + product.price.sellingPrice + ',' + quantity;
    if (event === 'purchase') {
        if (product.productInfo.productFulfillmentMethod === 'PHYSICAL') {
            item += ',Regular';
        } else if (product.productInfo.productFulfillmentMethod === 'PICKUP_BOPS') {
            item += ',BOPIS';
        } else if (product.productInfo.productFulfillmentMethod === 'SDD') {
            item += ',SDD';
        }
    } else if (product.productInfo.item_shipping_method) {
        item += ',' + product.productInfo.item_shipping_method;
    }
    return item;
}
/**
 * @returns {Object} - json event
 */
function tradeResultDetails() {
    var tradeResult;
    var searchTermEntered;
    var resultsCount;
    for (var i = 0; i < dataLayer.length; i++) {
        if ((dataLayer && (dataLayer[i].event === 'Trade In Searched'))) {
            tradeResult = dataLayer[i].listing;
            searchTermEntered = tradeResult.listingParams.searchInfo.searchTermEntered;
            resultsCount = tradeResult.listingResults.resultsCount;
            break;
        }
    }

    var tradeDetails = {
        resultsCount: resultsCount,
        searchTermEntered: searchTermEntered
    };

    return tradeDetails;
}
/**
 * @param {Object} action action object
 * @returns {Object} - json event
 */
function fetchProductDetails(action) {
    var currency = '';
    var productItem = [];
    var productTempItem = [];
    var totalPrice = 0;
    var products;
    var product;
    var quantity;
    var qtyValue;
    for (var i = 0; i < dataLayer.length; i++) {
        if ((dataLayer && (dataLayer[i].event === 'Cart Viewed')) || (dataLayer && dataLayer[i].event === 'Checkout Step Encountered') || (dataLayer && dataLayer[i].event === 'Order Placed')) {
            products = dataLayer[i].product || dataLayer[i].transaction.item;
            for (var j = 0; j < products.length; j++) {
                product = products[j];
                currency = product.price.currency;
                qtyValue = $('.quantity-value[data-pid="' + product.productInfo.sku + '"]')[0];
                quantity = $('.quantity[data-pid="' + product.productInfo.sku + '"]').val() || $(qtyValue).text() || 0;
                totalPrice += quantity * parseFloat(product.price.sellingPrice);
                if (action === 'view_cart' || action === 'begin_checkout' || action === 'add_payment_info' || action === 'add_shipping_info' || action === 'purchase') {
                    productItem.push(populateProductItem(product, quantity));
                    productTempItem.push(populateProductTempItem(product, quantity, action));
                }
            }
            break;
        }
    }
    var totalRevenue;
    if (action === 'begin_checkout' || action === 'add_payment_info' || action === 'add_shipping_info' || action === 'purchase') {
        totalRevenue = $('.container.cart .grand-total').text().substr(1) || $('.grand-total-sum')[0].innerText.substr(1);
    }
    var details = {
        currency: currency,
        value: action === 'begin_checkout' || action === 'add_payment_info' || action === 'add_shipping_info' || action === 'purchase' ? totalRevenue : totalPrice,
        items: productItem
    };
    if (productTempItem.length < 13) { // Maximum 25 (11 + 12) parameter is accepted on firebase, for safe keeping it 23
        for (var z = 0; z < productTempItem.length; z++) {
            details['temp_item' + z] = productTempItem[z];
        }
    }
    return details;
}

/**
 * @returns {Object} - order details object
 */
function fetchOrderDetails() {
    var orderDetails = {};
    for (var i = 0; i < dataLayer.length; i++) {
        if (dataLayer && dataLayer[i].event === 'Order Placed') {
            orderDetails.transaction_id = dataLayer[i].transaction.transactionID;
            orderDetails.affiliation = 'Google Store';
            orderDetails.currency = dataLayer[i].transaction.total.currency;
            orderDetails.value = Number(dataLayer[i].transaction.total.revenue);
            orderDetails.tax = dataLayer[i].transaction.total.tax;
            orderDetails.shipping = dataLayer[i].transaction.total.shippingCost;
            orderDetails.payment_type = dataLayer[i].transaction.payment_type ? dataLayer[i].transaction.payment_type : '';
            break;
        }
    }
    return orderDetails;
}

/**
 * @returns {string} - return coupon code
 */
function fetchCouponCode() {
    for (var i = 0; i < dataLayer.length; i++) {
        if (dataLayer && dataLayer[i].event === 'Promo Code Added') {
            if (dataLayer[i].voucherDiscount && dataLayer[i].voucherDiscount.voucherCodeIsValid === true) {
                return dataLayer[i].voucherDiscount.voucherCode;
            }
            break;
        }
    }
    return null;
}

/**
 * @returns {string} - return payment type
 */
function fetchPaymentType() {
    for (var i = 0; i < dataLayer.length; i++) {
        if (dataLayer[i].event === 'Checkout Step Encountered') {
            if (dataLayer[i].eventDetails && dataLayer[i].eventDetails.checkoutOption && dataLayer[i].eventDetails.checkoutOption.length) {
                return dataLayer[i].eventDetails && dataLayer[i].eventDetails.checkoutOption;
            }
        }
    }
    return '';
}

/**
 * @returns {string} - return coupon code
 */
function getCouponCodeOnOrderPlace() {
    var couponCode = '';
    for (var i = 0; i < dataLayer.length; i++) {
        if (dataLayer && dataLayer[i].event === 'Order Placed') {
            if (dataLayer[i].transaction && dataLayer[i].transaction.total) {
                var total = dataLayer[i].transaction.total;
                if (total.orderLevelDiscountCode || total.productLevelDiscountCode) {
                    couponCode = total.orderLevelDiscountCode ? total.orderLevelDiscountCode + ': ' + total.orderLevelDiscount : total.productLevelDiscountCode + ': ' + total.productDiscount;
                }
                break;
            }
        }
    }
    return couponCode;
}

/**
 * post RN event on adding payment info
 * @param {string} paymentType tells the payment type used
 */
function postMessageOnCheckoutPayment(paymentType) {
    var event = 'add_payment_info';

    var details = fetchProductDetails(event);
    var paymentMethod = $.trim($('.payment-options a.nav-link.active').text());
    if (paymentMethod === 'BUY NOW, PAY LATER' && paymentType === undefined) {
        return;
    }
    if (fetchCouponCode() != null) {
        details.coupon = fetchCouponCode();
    }
    if (paymentType) {
        details.payment_type = paymentType;
    } else {
        details.payment_type = fetchPaymentType();
    }
    details.checkout_step = '3';
    dataToReactNative(details, event);
}

/**
 * post RN event on adding shipping method
 */
function postMessageOnAddingShippingInfo() {
    var event = 'add_shipping_info';

    var details = fetchProductDetails(event);
    if (fetchCouponCode() != null) {
        details.coupon = fetchCouponCode();
    }
    details.checkout_step = '2';
    dataToReactNative(details, event);
}

/**
 *
 * @param {Object} product product object
 * @param {string|number} quantity product quantity
 */
function postMessageOnProductRemove(product, quantity) {
    var event = 'remove_from_cart';
    var totalPrice = fetchProductDetails(event).value;
    var value = totalPrice - (quantity * parseFloat(product.price.sellingPrice));
    var productDetails = product;
    var products;
    for (var i = 0; i < dataLayer.length; i++) {
        if (dataLayer[i].event === 'Cart Viewed') {
            products = dataLayer[i].product;
            for (var productItr = 0; productItr < products.length; productItr++) {
                if (dataLayer[i].product[productItr].productInfo && dataLayer[i].product[productItr].productInfo.productID === product.productInfo.productID) {
                    productDetails = dataLayer[i].product[productItr];
                    break;
                }
            }
            break;
        }
    }
    var details = {
        currency: product.price.currency,
        value: value,
        items: populateProductItem(productDetails, quantity),
        temp_item0: populateProductTempItem(product, quantity)
    };

    if (isAppSession === 'true') {
        dataToReactNative(details, event);
    }
}

/**
 * @param {Object} productObject The product data
 * @param {string} position position of product in the list
 * @param {string} listItemType recommendation zone type
 * @description gets the data for a product clicked in recommendation zone
 */
function recomProductClick(productObject, position, listItemType) {
    var obj = {
        event: 'Product Impression Click',
        ecommerce: {
            click: {
                actionfield: {
                    list: listItemType
                },
                products: []
            }
        }
    };
    var recomposition = position;
    var recomProductObject = productObject;
    recomProductObject.itemPosition = recomposition;
    obj.ecommerce.click.products.push(recomProductObject);
    dataLayer.push(obj);
}

/**
 *
 * @param {Object} productObject product object
 * @param {string|number} quantity product quantity
 * @param {string|Object} source source
 * @param {Object} warrantyData game plan warranty data object
 */
function removeFromCart(productObject, quantity, source, warrantyData) {

    if (!productObject) {
        return;
    }

    var quantityObj = {
        quantity: quantity
    };
    productObject.productInfo.productState = source;        // eslint-disable-line no-param-reassign
    var obj = {
        event: 'Product Removed',
        product: []

    };

    if (warrantyData) {
        productObject.productInfo.warrantyOption = warrantyData.warrantyId; // eslint-disable-line no-param-reassign
    }

    obj.product.push($.extend(productObject, quantityObj));

    // Game Warranty Analytics
    var warrantyProductObj = warrantyData && {
        quantity: 1,
        productInfo: {
            sku: warrantyData.warrantyId,
            productID: warrantyData.warrantyId,
            name: warrantyData.warrantyName,
            warrantyOption: warrantyData.warrantyId,
            productType: 'Warranty',
            parentProduct: warrantyData.parentProductName
        },
        price: {
            sellingPrice: warrantyData.warrantyPrice,
            basePrice: warrantyData.warrantyPrice
        }
    };

    if (warrantyProductObj) {
        obj.product.push(warrantyProductObj);
    }

    dataLayer.push(obj);

    if (isAppSession && window.pageContext.ns === 'cart') {
        postMessageOnProductRemove(productObject, quantity);
    }
}

/**
* Remove product from mini cart
* @param {Object} productObject product object
* @param {string|number} quantity product quantity
* @param {Object} warrantyData game plan warranty data object
* @param {string|number} miniCartSubTotal miniCart sub total quantity
* @param {string} eventLabel event label
*/
function removeFromMiniCart(productObject, quantity, warrantyData, miniCartSubTotal, eventLabel) {

    if (!productObject) {return;}

    var customDimension = {
        gtmContainerId: $('#googleTagManagerIdNew').val(),
        searchInput: productObject && productObject.searchInput,
        productSKU: productObject && productObject.id,
        searchAutocompleteCategory: productObject && productObject.searchAutocompleteCategory,
        searchAutocompleteValue: productObject && productObject.searchAutocompleteValue,
        cartValue: miniCartSubTotal,
        componentType: productObject && productObject.componentType,
        experienceType: productObject && productObject.experienceType,
        filterType: productObject && productObject.filterType,
        filterValue: productObject && productObject.filterValue,
        persistentSignIn: productObject && productObject.persistentSignIn,
        storeId: productObject && productObject.storeId,
        memberTier: productObject && productObject.memberTier,
        authenticationState: productObject && productObject.authenticationState,
        paymentType: productObject && productObject.paymentType,
        reviewsRating: productObject && productObject.reviewsRating,
        reviewsNumber: productObject && productObject.reviewsNumber
    };
    var customMetric = {
        orderDiscount: productObject && productObject.orderDiscount,
        eventValue: productObject && productObject.eventValue
    };
    var obj = {
        event: 'analyticsEvent',
        eventCategory: 'ecommerce',
        eventAction: 'product removed',
        eventLabel: eventLabel,
        customDimensions: customDimension,
        customMetrics: customMetric,
        ecommerce: {
            remove: {
                products: []
            }
        }
    };
    var productObj = productObject;
    if (warrantyData && productObj) {
        productObj.dimension18 = warrantyData.warrantyId;
    }
    productObj.quantity = quantity;

 // Game Warranty Analytics
    var warrantyProductObj = warrantyData && {
        name: warrantyData.warrantyName,
        id: warrantyData.warrantyId,
        price: warrantyData.warrantyPrice && warrantyData.warrantyPrice.replace('$', ''),
        brand: '',
        category: '',
        variant: '',
        quantity: 1,
        dimension13: '',
        dimension14: '',
        dimension15: '',
        dimension16: '',
        dimension17: '',
        dimension19: productObject.id
    };
    obj.ecommerce.remove.products.push(productObj);
    if (warrantyProductObj) {
        obj.ecommerce.remove.products.push(warrantyProductObj);
    }

    dataLayer.push(obj);
}
/**
 * Updates the current step in the checkout flow
 * @param {number} step - checkout step
 */
function checkoutStepEncountered(step) {
    var gtmData = $('#checkout-main').data('gtmdata');
    if (!gtmData || step > 5) {
        return;
    }

    var checkoutOption = '';
    var $shippingMethod = $('[id^="shippingMethod"]:checked');
    if (step === 3 && $shippingMethod.length > 0) {
        checkoutOption = $.trim($shippingMethod.closest('.custom-control').find('.display-name').html());
    }
    var $paymentMethod = $('.payment-options .active[data-toggle="tab"]');
    if ((step === 4 || step === 5) && $paymentMethod.length > 0) {
        checkoutOption = $.trim($paymentMethod.text());
        if (checkoutOption === 'PayPal' && sessionStorage.getItem('paypalExpressCart')) {
            checkoutOption = sessionStorage.getItem('paypalExpressCart');
        }
    }

    dataLayer.push({
        event: 'Checkout Step Encountered',
        eventDetails: {
            checkoutStep: step,
            checkoutOption: checkoutOption
        },
        product: gtmData.product
    });
}

/**
 * @param {Object} elem - selector or dom element
 * @returns {bool} - is element visible or not
 */
function isScrolledIntoView(elem) {
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

/**
 * Handles promotion viewed event
 */
function promotionViewed() {
    var promotions = [];
    window.gtmSentPromotions = window.gtmSentPromotions || [];
    $('[data-row-index][data-row-position][data-block-index][data-block-position]').each(function () {
        var el = $(this);
        var promotionId = el.data('promotionID');
        if (promotionId && window.gtmSentPromotions.indexOf(promotionId) !== -1 && isScrolledIntoView(el)) {
            window.gtmSentPromotions.push(promotionId);
            promotions.push({
                promotionID: promotionId,
                promotionPosition: el.data('promotionPosition'),
                promotionCreative: el.data('promotionCreative'),
                promotionName: el.data('promotionName')
            });
        }
    });
    if (promotions.length > 0) {
        dataLayer.push({
            event: 'Promotion Viewed',
            promotions: promotions
        });
    }
}

/**
 * pass selected shipment to GTM
 * @param {string} option shipment text
 *
 */
function shipmentSelected(option) {
    if (option) {
        dataLayer.push({
            shipmentType: {
                shipmentSelected: option
            },
            event: 'shipment type selection'
        });
    }
}

/**
 * pass selected user to GTM
 * @param {string} option user text
 *
 */
function selectPurUserType(option) {
    if (option) {
        dataLayer.push({
            eventDetails: {
                eventAction: 'Create Account',
                eventLabel: option
            },
            event: 'Power Up Rewards'
        });
    }
}

/**
 * add xaa line of credit application form submitted event
 */
function xaaLOCFormSubmitted() {
    dataLayer.push({
        eventDetails: {
            eventAction: 'XAA Form Submitted'
        },
        event: 'XAA Interactions'
    });
}

/**
 * pass enrollment status to GTM
 * @param {string} option user text
 *
 */
function selectEnrollmentStatus(option) {
    if (option) {
        dataLayer.push({
            eventDetails: {
                eventAction: 'Join As A Player',
                eventLabel: option
            },
            event: 'Power Up Rewards'
        });
    }
}

/**
 *
 * @param {Object} event event object
 * @param {boolean} checkoutBtnClicked Checkout Btn clicked
 * @param {boolean} stepCheckout Stepchckout
 */
function postMessageOnEvent(event, checkoutBtnClicked, stepCheckout) {
    var details = {
        productDetails: fetchProductDetails(event)
    };
    if (fetchCouponCode() != null && checkoutBtnClicked) {
        details.coupon = fetchCouponCode();
    }
    if (stepCheckout) {
        details.productDetails.checkout_step = '1';
    }
    if (event === 'view_cart') {
        var flexpayEnableInApp = $('#flexpay-enable-in-app').val();
        if (flexpayEnableInApp === 'true') {
            details.productDetails.display_flexible_payment = 'yes';
        } else {
            details.productDetails.display_flexible_payment = 'no';
        }
    }
    var json = {
        message: 'callFBEvent',
        eventDetails: details.productDetails,
        event: event
    };
    try {
        window.ReactNativeWebView.postMessage(JSON.stringify(json));
    } catch (e) {
        console.log(e);
    }
}

/**
 * @param {Object} productInfo product info
 * @returns {string} - category3
 */
function populateItemVariant(productInfo) {
    var variant = '';
    if (productInfo) {
        if (productInfo.productType === 'Warranty') {
            variant = 'Warranty | ' + productInfo.parentProduct;
        } else {
            variant = productInfo.warranty_name ? 'Warranty | Parent | ' + productInfo.warranty_name : '';
        }
    }
    return variant;
}

/**
 * @param {Object} productInfo product info
 * @returns {string} - category3
 */
function populateItemCategory3(productInfo) {
    var category = '';
    if (productInfo) {
        var shippingMethod = productInfo.item_shipping_method;
        switch (shippingMethod) {
            case 'SDD':
                category = shippingMethod + ' | ' + shippingMethod + ' | ' + productInfo.shippingOption;
                break;
            case 'Regular':
                category = shippingMethod + ' | ' + productInfo.productFulfillmentMethod + ' | ' + productInfo.shippingOption;
                break;
            default:
                // TODO: Pass "No Shipping Method Selected" if no shipping options available or for Guest Checkout.
                if (customerType === 'guest') {
                    category = 'No Shipping Method Selected';
                } else {
                    category = shippingMethod + ' | ' + productInfo.productFulfillmentMethod;
                }
                break;
        }
    }
    return category;
}

/**
 * @param {Object} product product info
 * @returns {Object} - categoryInfo
 */
function getWarrantyCategoryInfo(product) {
    for (var i = 0; i < dataLayer.length; i++) {
        if (dataLayer && (dataLayer[i].event === 'Checkout Step Encountered' || dataLayer[i].event === 'Order Placed')) {
            var products = dataLayer[i].product || dataLayer[i].transaction.item;
            for (var j = 0; j < products.length; j++) {
                if (products[j].productInfo.productID === product.parentProductID) {
                    return {
                        category3: populateItemCategory3(products[j].productInfo),
                        category5: products[j].productInfo.item_shipping_method
                    };
                }
            }
        }
    }
    return {
        category3: '',
        category5: ''
    };
}

/**
 * @param {Object} product product object
 * @param {string|number} quantity product quantity
 * @returns {Object} - json object
 */
function populateProductItemOnSPC(product, quantity) {
    var warrantyType = product && product.productInfo.productType === 'Warranty';
    var category3 = populateItemCategory3(product.productInfo);
    var variant = populateItemVariant(product.productInfo);
    var warrantyCategoryInfo;
    if (warrantyType) {
        warrantyCategoryInfo = getWarrantyCategoryInfo(product.productInfo);
    }
    var item;
    item = {
        quantity: typeof quantity === 'string' ? parseInt(quantity, 10) : quantity,
        price: parseFloat(product.price.sellingPrice),
        item_brand: warrantyType ? 'GameStop Inc.' : product.productInfo.brand,
        item_category: warrantyType ? product.productInfo.parentProductCategory : product.productInfo.category,
        item_category2: warrantyType ? 'Digital' : product.productInfo.condition,
        item_category3: warrantyType ? warrantyCategoryInfo.category3 : category3,
        item_category4: warrantyType ? 'Available' : product.productInfo.availability,
        item_category5: warrantyType ? warrantyCategoryInfo.category5 : product.productInfo.item_shipping_method,
        item_id: warrantyType ? product.productInfo.productId : product.productInfo.productID,
        item_name: product.productInfo.name,
        item_variant: variant
    };

    return item;
}

/**
 * @param {Object} action action object
 * @param {string} paymentMethod payment name
 * @returns {Object} - json event
 */
function fetchProductDetailsOnSPC(action, paymentMethod) {
    var currency = '';
    var productItem = [];
    var totalPrice = 0;
    var products;
    var product;
    var quantity;
    for (var i = 0; i < dataLayer.length; i++) {
        if (dataLayer && (dataLayer[i].event === 'Checkout Step Encountered' || dataLayer[i].event === 'Order Placed')) {
            products = dataLayer[i].product || dataLayer[i].transaction.item;
            for (var j = 0; j < products.length; j++) {
                product = products[j];
                currency = product.price.currency || 'USD';
                quantity = product.quantity;
                totalPrice += quantity * parseFloat(product.price.sellingPrice);
                if (action === 'begin_checkout' || action === 'add_shipping_info' || action === 'add_payment_info' || action === 'purchase') {
                    productItem.push(populateProductItemOnSPC(product, quantity));
                }
            }
            break;
        }
    }

    var $total = $('.grand-total');
    if ($total.length) {
        totalPrice = $total.text();
        totalPrice = parseFloat(totalPrice.substring(totalPrice.indexOf('$') + 1));
    }

    var details = {
        currency: currency,
        value: totalPrice,
        items: productItem
    };

    if (action === 'add_payment_info' && paymentMethod) {
        details.payment_type = paymentMethod;
    }
    return details;
}

/**
 *
 * @returns {Object} - json event
 */
function getCouponInfoSPC() {
    var $coupons = $('.os-discount').find('.coupon');
    var coupons = [];
    if ($coupons.length > 0) {
        $coupons.each(function (i, coupon) {
            var discountAmount = $(coupon).find('.discount-amount').text().trim();
            coupons.push({
                code: $(coupon).find('.coupon-name').text().trim(),
                amount: parseFloat(discountAmount.substring(discountAmount.indexOf('$') + 1))
            });
        });
    }

    return coupons.length > 0 ? coupons : null;
}

/**
 * Post message to RN on SPC page
 * @param {string} event name
 * @param {string} paymentMethod name
 */
function postMessageOnSPC(event, paymentMethod) {
    var details = fetchProductDetailsOnSPC(event, paymentMethod);
    if (event === 'add_shipping_info' || event === 'add_payment_info') {
        var coupons = getCouponInfoSPC();
        var result = '';
        if (coupons) {
            coupons.forEach(function (coupon) {
                result = result === '' ? result + coupon.code + ' : ' + coupon.amount : result + ', ' + coupon.code + ' : ' + coupon.amount;
            });
        }

        var $gifCard = $('#giftCertificateAmount');
        if ($gifCard.length && parseFloat($gifCard.val()) !== 0.0) {
            result = result === '' ? 'Gift Card : ' + parseFloat($gifCard.val()) : result + ' | Gift Card : ' + parseFloat($gifCard.val());
        }
        details.coupon = result !== '' ? result : 'No Rewards Applied';
    }
    dataToReactNative(details, event);
}

/**
 * post RN event on order place
 */
function postMessageOnOrderPlace() {
    var event = 'purchase';
    var details;
    var productCartItems = fetchProductDetailsOnSPC(event);
    var orderDetails = fetchOrderDetails();
    var couponCode = getCouponCodeOnOrderPlace();

    details = Object.assign(orderDetails, productCartItems);
    details.checkout_step = '4';

    if (couponCode.length) {
        details.coupon = couponCode;
    }
    details.value = parseFloat(details.value);
    dataToReactNative(details, event);
}

/**
 * Post RN event on single page checkout screen view
 * @param {string} event name
 */
function postMessageScreenViewOnSPC(event) {
    var details = {
        screen_name: 'checkout',
        screen_category: 'Checkout'
    };
    dataToReactNative(details, event);
}

/**
 * Trigger the event and pass the details to RN
 * @param {string} componentName Component name
 * @param {Object} eventDetail Event Details
 * @param {string} pagecontext Current Page Context
 * @param {string} event Event
 */
function triggerRNEvent(componentName, eventDetail, pagecontext, event) {
    var detail = {
        component: componentName,
        details: eventDetail,
        source: pagecontext
    };
    dataToReactNative(detail, event);
}

if (isAppSession === 'true') {
    if (window.pageContext.ns === 'orderconfirmation') {
        dataToReactNative({
            screen_class: 'Order Confirmation',
            screen_name: 'Purchase'
        }, 'orderconfirmation_screenview');
        postMessageOnOrderPlace();
        var orderConfirmShippingViewed = false;
        var orderConfirmPaymentViewed = false;

        $(window).on('resize scroll', function () {
            var elShipping = $('.order-summary-shipping');
            if (isScrolledIntoView(elShipping) && !orderConfirmShippingViewed) {
                orderConfirmShippingViewed = true;
                triggerRNEvent('Shipping', 'Component: Shipping | Viewed', 'Order Confirmation', customLink);
            }
            var elPayment = $('.order-summary-shipping');
            if (isScrolledIntoView(elPayment) && !orderConfirmPaymentViewed) {
                orderConfirmPaymentViewed = true;
                triggerRNEvent('Payment', 'Component: Payment | Viewed', 'Order Confirmation', customLink);
            }
        });

        $('body').on('orderconfirmation:appanalytics', function () {
            triggerRNEvent('Return to Shopping', 'Link: Return to Shopping | Clicked', 'Order Confirmation', customLink);
        });
    }

    if (window.pageContext.ns === 'cart' && !$('.cart-empty').length) {
        postMessageOnEvent('view_cart');
    }

    if (window.pageContext.ns.toLowerCase().includes('checkout')) {
        postMessageScreenViewOnSPC('checkout_screenview');
        postMessageOnSPC('begin_checkout');
        triggerRNEvent('Shipping', 'Component: Shipping | Viewed', window.pageContext.ns, 'view_shipping_component');
        postMessageOnSPC('add_shipping_info');
        // TODO: Check if it is a member with no address
        if (customerType === 'guest' || (customerType === 'registered' && $('#checkout-main').find('form.shipping-form').hasClass('guest-checkout'))) {
            triggerRNEvent('Shipping', 'Component: Shipping | No Address Available', window.pageContext.ns, customLink);
        }

        $('body').on('checkout:paymentFormView', function () {
            triggerRNEvent('Payment', 'Component: Payment | Form View', window.pageContext.ns, customLink);
        });

        $('body').on('checkout:appPaymentInitiated', function (e, data) {
            triggerRNEvent('Place Order CTA', 'CTA: Payment Initiated | ' + data.payment, window.pageContext.ns, customLink);
        });

        $('#klarna-checkout-btn').on('click', function () {
            triggerRNEvent('Place Order CTA', 'CTA: Payment Initiated | Klarna', window.pageContext.ns, customLink);
        });
    }
}

/**
 * pass suggestion status to GTM
 * @param {string} data text
 *
 */
function searchSuggestionEvent(data) {
    var resultCheck = data.resultVal;
    dataLayer.push({
        eventDetails: {
            eventAction: resultCheck ? data.resultVal : 'Search Cancel',
            eventLabel: data.queryData
        },
        event: resultCheck ? 'Internal Search' : 'Search Cancel'
    });
}

/**
 * pass suggestion status to GTM
 * @param {string} domObj text
 * @return {string} - true or false
 *
 */
function isCheckedRadioOptions(domObj) {
    var isChecked = $(domObj).filter(function () {
        return $(this).prop('checked');
    });
    return isChecked;
}

/**
 * pass suggestion status to GTM
 * @param {string} productObj text
 * @return {string} - product data
 *
 */
function addToCartWarrantyList(productObj) {
    var pageContext = window.pageContext.ns;
    var productObjData = productObj;
    var checkedWarranty = isCheckedRadioOptions('.primary-details-row  .warranty-option');

    if (pageContext === 'search') {
        productObjData.list = {
            listName: 'Product list'
        };
    }

    if (pageContext === 'product' && checkedWarranty.length > 0) {
        productObjData.list = {
            listName: 'PDP|Warranty'
        };
    }

    return productObjData;
}

/**
 * pass suggestion status to GTM
 * @return {string} - product data
 *
 */
function returnWarrantyOptionParent() {
    var componentNameParent = '';
    $('.primary-details-row  .warranty-option').each(function (index) {
        var commorOper = (index === 0) ? '' : ', ';
        componentNameParent += commorOper + $.trim($(this).data('display-value'));
    });

    return componentNameParent;
}

/**
 * pass suggestion status to GTM
 * @param {Object} e - event
 * @param {Object} response - product variation response object
 * @deprecated - can be removed if there is no issue
 */
function productViewWarrantyImpression(e, response) {
    var pageContext = window.pageContext.ns;
    var checkedWarranty = $('.primary-details-row  .warranty-option');
    if (pageContext === 'product' && checkedWarranty.length === 0) {
        return;
    }
    var sliceProductObject;
    var productViewedIndex;
    var productObject = {};
    var dataLayerobj = dataLayer.map(function (x) {
        return x;
    });
    var prodViewedObj = {
        event: 'Product Viewed',
        certifiedRefurbished: response.data.product.isCertifiedRefurbished && (response.data.product.productCondition.toLocaleLowerCase().indexOf('refurbished') !== -1),
        product: []
    };
    for (var i = 0; i < dataLayerobj.length; i++) {
        if (dataLayerobj[i].event === 'Product Viewed') {
            productViewedIndex = i;
            var pdata = dataLayerobj.splice(i, 1);
            sliceProductObject = pdata[0].product[0];
            break;
        }
    }

    var componentName = returnWarrantyOptionParent();
    productObject.componentInfo = {
        componentDetails: 'Warranty|' + componentName + '|Parent'
    };

    prodViewedObj.product.push($.extend({}, sliceProductObject, productObject));

    $('.primary-details-row  .warranty-option').each(function () {
        var id = $(this).data('value-id');
        var childComponentName = $.trim($(this).data('display-value'));
        var warrantyprice = $(this).data('warranty-price');
        productObject.componentInfo = {
            componentDetails: 'Warranty|' + childComponentName + '|Up-sell'
        };
        productObject.price = {
            sellingPrice: warrantyprice.replace('$', ''),
            basePrice: warrantyprice.replace('$', ''),
            currency: 'USD'
        };
        productObject.productInfo = {
            name: childComponentName,
            parentProduct: sliceProductObject.productInfo.name,
            productID: id,
            productType: 'Warranty',
            sku: id,
            warrantyOption: id
        };
        productObject.productInfo = $.extend({}, sliceProductObject.productInfo, productObject.productInfo);
        prodViewedObj.product.push($.extend({}, sliceProductObject, productObject));
    });
    dataLayer.splice(productViewedIndex, 1, prodViewedObj);
}

/**
 * Triggers payment section analytics just once when we scroll into payment section
 * @param {Object} entry - all the entries
 * @param {Object} self - the current object
 *
 */
function intersectPaymentSection(entry, self) {
    if (entry[0].isIntersecting && !isPaymentElementVisible) {
        $('body').trigger('checkout:paymentSectionAnalytics', { checkoutStep: '5a', checkoutOption: 'Credit Card' });
        if (isAppSession === 'true') {
            triggerRNEvent('Payment', 'Component: Payment | Viewed', window.pageContext.ns, 'view_payment_component');
            var savedCreditCardCount = $('#savedCreditCardCount').val();
            if (savedCreditCardCount === 'null' || parseInt(savedCreditCardCount, 10) === 0) {
                triggerRNEvent('Payment', 'Component: Payment | No Payment Method Available', window.pageContext.ns, customLink);
                postMessageOnSPC('add_payment_info', 'CREDIT_CARD');
            }
        }
        self.unobserve(entry[0].target);
        isPaymentElementVisible = true;
    }
}

/**
 * Returns the coupon details like code and net savings
 * @param {Object} detailsObj - response
 * @return {Object} - coupon details
 *
 */
function couponDetails(detailsObj) {
    var details = {
        couponCode: '',
        value: 0
    };
    var data = detailsObj.data;
    var discounts = data.totals.discounts;
    if (discounts) {
        $.each(discounts, function (count) {
            var discount = discounts[count];
            if (discount.valid && discount.applied && discount.type === 'coupon') {
                details.couponCode = discount.couponCode;
                if (discount.relationship && discount.relationship.length) {
                    var couponDiscountAmount = discount.relationship[0].price.formatted;
                    if (couponDiscountAmount.indexOf('$') > -1) {
                        details.value = parseFloat(couponDiscountAmount.substring(couponDiscountAmount.indexOf('$') + 1));
                    }
                }
            }
        });
    }
    return details;
}

/**
 * Returns the coupon details like code and net savings
 * @param {Object} source - Source
 * @return {Object} - zone and placement details
 *
 */
function googleAIRecommendationSource(source) {
    var zonesource;
    var placement;
    var listImpression;
    if (source === 'PEOPLE_ALSO_BOUGHT') {
        zonesource = 'PDP';
        placement = 'PDP (2) - People also bought';
        listImpression = 'pdp:people_also_bought';
    } else if (source === 'MORE_LIKE_THIS') {
        zonesource = 'PDP';
        placement = 'PDP (1)- More like this';
        listImpression = 'pdp:more_like_this';
    } else if (source === 'SEARCH') {
        zonesource = 'Search';
        placement = 'Search Page';
        listImpression = 'plp:you_might_also_like';
    } else if (source === 'PLP') {
        zonesource = 'PLP';
        placement = 'PLP - Recommended-for-you';
        listImpression = 'plp:you_might_also_like';
    } else if (source === 'NO_SEARCH_RESULT') {
        zonesource = 'pageType-Null Search';
        placement = 'No results search';
        listImpression = '';
    } else if (source === 'HOME_PAGE') {
        zonesource = 'Home';
        placement = 'Homepage';
        listImpression = 'Homepage:recommended_products';
    } else if (source === 'ATC_MODAL') {
        zonesource = 'ATC Modal';
        placement = 'Add to Cart';
        listImpression = '';
    } else {
        zonesource = '';
        placement = '';
        listImpression = '';
    }
    return {
        zonesource: zonesource,
        placement: placement,
        listImpression: listImpression
    };
}

var events = {
    account: function () { },
    store: function () {
        $(document).on('click', '.store-locator-search-stores-container .results-card .store-name a', function () {
            var gtmData = $(this).closest('.card-body').data('gtmdata');
            if (!gtmData) {
                return;
            }

            gtmData.storeSearch.selectAction = 'Store Name';
            dataLayer.push(gtmData);
        });
        $(document).on('click', '.store-locator-search-stores-container .results-card .store-phone a', function () {
            var gtmData = $(this).closest('.card-body').data('gtmdata');
            if (!gtmData) {
                return;
            }

            gtmData.storeSearch.selectAction = 'Phone Number';
            dataLayer.push(gtmData);
        });
        $(document).on('click', '.store-locator-search-stores-container .results-card .store-directions-link', function () {
            var gtmData = $(this).closest('.card-body').data('gtmdata');
            if (!gtmData) {
                return;
            }

            gtmData.storeSearch.selectAction = 'Directions';
            dataLayer.push(gtmData);
        });
        $(document).on('click', '.store-locator-search-stores-container .results-card .store-details-link', function () {
            var gtmData = $(this).closest('.card-body').data('gtmdata');
            if (!gtmData) {
                return;
            }

            gtmData.storeSearch.selectAction = 'Store Details';
            dataLayer.push(gtmData);
        });
        $(document).on('click', '.store-locator-search-stores-container .results-card .my-store-link', function () {
            var gtmData = $(this).closest('.card-body').data('gtmdata');
            if (!gtmData) {
                return;
            }

            gtmData.storeSearch.selectAction = 'Set As Home Store';
            dataLayer.push(gtmData);
        });
    },
    cart: function () {
        $(document).on('cart-promo-applied:error', function (e, code) {
            dataLayer.push({
                voucherDiscount: {
                    voucherCodeIsValid: false,
                    voucherCode: code
                },
                event: 'Promo Code Added'
            });
        });
        $(document).on('cart-promo-applied:success', function (e, code) {
            dataLayer.push({
                voucherDiscount: {
                    voucherCodeIsValid: true,
                    voucherCode: code
                },
                event: 'Promo Code Added'
            });
        });
        $('.checkout-and-applepay .checkout-btn, .checkout-and-applepay .checkout-btn-header').on('click', function () {
            var product = [];
            for (var i = dataLayer.length - 1; i > 0; i--) {
                if ((dataLayer && (dataLayer[i].event === 'Cart Viewed')) || (dataLayer && dataLayer[i].event === 'Checkout Step Encountered')) {
                    product = dataLayer[i].product;
                    if (dataLayer[i].event === 'Checkout Step Encountered') {
                        for (var j = 0; j < product.length; j++) {
                            if (product[j].productInfo) {
                                product[j].productInfo.beginCheckout = 1;
                            }
                            if (product[j].productInfo.appliedPromotion && product[j].productInfo.appliedPromotion === 'PriceMatch') {
                                product[j].productInfo.promoLabel = 'PriceMatch';
                            }
                        }
                    }
                    break;
                }
            }
            dataLayer.push({
                event: 'Checkout Step Encountered',
                eventDetails: {
                    checkoutStep: 2,
                    checkoutOption: ''
                },
                product: product
            });
        });
        $(document).on('cart-paypal-checkout:start', function () {
            var product = [];
            for (var i = dataLayer.length - 1; i > 0; i--) {
                if ((dataLayer && (dataLayer[i].event === 'Cart Viewed')) || (dataLayer && dataLayer[i].event === 'Checkout Step Encountered')) {
                    product = dataLayer[i].product;
                    if (dataLayer[i].event === 'Checkout Step Encountered') {
                        for (var j = 0; j < product.length; j++) {
                            if (product[j].productInfo) {
                                product[j].productInfo.beginCheckout = 1;
                            }
                            if (product[j].productInfo.appliedPromotion && product[j].productInfo.appliedPromotion === 'PriceMatch') {
                                product[j].productInfo.promoLabel = 'PriceMatch';
                            }
                        }
                    }
                    break;
                }
            }
            dataLayer.push({
                event: 'Checkout Step Encountered',
                eventDetails: {
                    checkoutStep: '5b',
                    checkoutOption: 'Paypal Express'
                },
                product: product
            });
        });
        $(document).on('cart-paypal-checkout:error', function (e, errorMessage) {
            dataLayer.push({
                errorDetails: {
                    errorCategory: 'ecommerce',
                    errorTrigger: 'Paypal Express Transaction Error',
                    errorType: 'Paypal Express',
                    errorMessage: errorMessage || ''
                },
                event: 'Error Occurence'
            });
        });
        $(document).on('cart:protectionAdded:success', function (e, protection) {
            dataLayer.push({
                protectionDetails: {
                    name: protection.optionDisplayName,
                    totalValue: protection.itemTotal,
                    protectionValue: protection.protectionValue,
                    protectionId: protection.protectionValue
                },
                event: 'Protection added in cart'
            });
        });
        $(document).on('cart:protectionRemoved:success', function (e, protection) {
            dataLayer.push({
                protectionDetails: {
                    name: protection.optionDisplayName,
                    totalValue: protection.itemTotal,
                    protectionValue: protection.protectionValue,
                    protectionId: protection.protectionValue
                },
                event: 'Protection removed in cart'
            });
        });
        $('.protection-button.unselected').on('click', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'Warranty Selection|Cart',
                    eventLabel: 'Warranty Added'
                },
                event: 'ecommerce'
            });
        });
        $('.protection-button.selected').on('click', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'Warranty Selection|Cart',
                    eventLabel: 'Warranty Removed'
                },
                event: 'ecommerce'
            });
        });
        $(document).on('cart:afterAddToCartRecommendation', function (e, data) {
            if (data && data.gtmData) {
                dataLayer.push({
                    product: [data.gtmData],
                    event: 'Recommended Product Added - Cart page'
                });
                dataLayer.push({
                    productDetails: data.resultval,
                    event: 'Product Option Selected - Cart page'
                });
            }
            if (data && data.gtmPURData) {
                dataLayer.push({
                    product: [data.gtmPURData],
                    event: 'Recommended Giftcard Added - Cart page'
                });
            }
            if (data && data.gtmData) {
                var productObj = data.gtmData;
                productObj.productInfo.zoneSource = 'Cart';
                productObj.componentInfo = {
                    componentDetails: 'Recommendation | More Like This | cross-sell'
                };
                var list = {
                    listName: 'Cart | More Like This'
                };
                dataLayer.push({
                    product: [productObj],
                    list: list,
                    event: 'Product Added'
                });
            }
        }
        );
        $(document).on('cart:upsellGiftCard:afterPageLoad', function (e, data) {
            dataLayer.push({
                product: [data],
                event: 'Product Viewed'
            });
        });

        $(document).on('cart:UpsellGiftCard:afterAdded', function (e, data) {
            var gtmData = data;
            var isMobileView = data && data.isMobileView;

            if (isMobileView === 'true') {
                var isTopUpsellGCSection = gtmData.isTopUpsellGCSection && Number(gtmData.isTopUpsellGCSection);
                var isBottomUpsellGCSection = gtmData.isBottomUpsellGCSection && Number(gtmData.isBottomUpsellGCSection);
                if (isTopUpsellGCSection) {
                    gtmData.gtmProductData.productInfo.zoneSource = 'cart|top';
                }

                if (isBottomUpsellGCSection) {
                    gtmData.gtmProductData.productInfo.zoneSource = 'cart|bottom';
                }
            }

            dataLayer.push({
                product: [gtmData && gtmData.gtmProductData],
                event: 'Product Added'
            });
        });
    },
    checkoutlogin: function () {
        $('.checkout-as-guest').on('click', function () {
            if (isAppSession === 'true') {
                var event = 'custom_link';
                var details = {
                    component: 'Signin modal',
                    detail: 'Guest Checkout',
                    source: window.pageContext.ns
                };
                dataToReactNative(details, event);
            } else {
                var gtmSessionData = $(this).data('gtmdata');
                if (!gtmSessionData) {
                    return;
                }
                dataLayer.push({
                    user: {
                        userType: gtmSessionData.user.userType,
                        memberTier: gtmSessionData.user.memberTier,
                        memberSinceDate: gtmSessionData.user.memberSinceDate,
                        loyaltyPoints: gtmSessionData.user.loyaltyPoints,
                        loginStatus: gtmSessionData.user.loginStatus,
                        custKey: gtmSessionData.user.custKey,
                        lastOrderDate: gtmSessionData.user.lastOrderDate,
                        customerStatus: gtmSessionData.user.customerStatus
                    },
                    event: 'Guest Checked Out'
                });
            }
        });
    },
    checkout: function () {
        $(document).on('click', '[name$="_shippingMethodID"]', function () {
            var shippingMethod = $.trim($(this).closest('.shipping-method-set').find('.display-name').text());
            var checkoutOption = shippingMethod;
            dataLayer.push({
                step: 3,
                eventDetails: {
                    checkoutOption: checkoutOption
                },
                event: 'Checkout Option Selected'
            });
        });

        // DEN-15029 New Checkout
        var moreClick = 1;
        $('.view-more-button.view-more-button-ordersummary').on('click', function () {
            if (moreClick === 1) {
                dataLayer.push({
                    eventDetails: {
                        eventCategory: 'ecommerce|Checkout',
                        eventAction: 'Order Summary | Click on More'
                    },
                    event: 'Checkout Step updated'
                });
            }
            moreClick++;
        });

        $('.payment-options a.nav-link').on('click', function () {
            if ($('.single-page-checkout').length) {
                return;
            }
            var paymentMthod = $.trim($(this).text());
            var checkoutOption = paymentMthod;
            dataLayer.push({
                step: 4,
                eventDetails: {
                    checkoutOption: checkoutOption
                },
                event: 'Checkout Option Selected'
            });
        });

        $('body').on('checkout:beforeUpdateStage', function (e, data) {
            if ($('.single-page-checkout').length) {
                return;
            }
            if (data.stage || data.stage === 0) {
                var stage = data.stage + 4;
                checkoutStepEncountered(stage);
            }
        });

        if (isAppSession === 'true' && window.pageContext.ns === 'checkout') {
            $('.submit-shipping').on('click', function () {
                postMessageOnAddingShippingInfo();
            });

            $('.submit-payment').on('click', function () {
                postMessageOnCheckoutPayment();
            });
            $('#klarna-checkout-btn').on('click', function () {
                postMessageOnCheckoutPayment('KLARNA');
            });
        }
    },
    compare: function () { },
    product: function () {
        $('body').on('product:afterProductViewWarranty', function (e, response) {
            productViewWarrantyImpression(e, response);
        });
    },
    search: function () {
        $('.search-results').on('click', '.refinement-bar a', function () {
            var label = $(this).find('label').text();
            if (!label) {
                label = $(this).find('span').text();
            }
            var plpFilterVal = $('.savefilter').attr('savefilter');
            var preplpFilterVal = plpFilterVal === undefined || plpFilterVal === '' ? label : plpFilterVal.toString().concat('|' + label);
            var replaceFilterVal = preplpFilterVal.replace(/\s\s+/g, '');
            $('.savefilter').attr('savefilter', replaceFilterVal);
            if (label) {
                dataLayer.push({
                    filterClicked: {
                        label: $.trim(label)
                    },
                    event: 'Filter Clicked'
                });
                dataLayer.push({
                    filterPilldetails: {
                        pillsSelected: replaceFilterVal
                    },
                    event: 'PLP Pills Filter'
                });
            }
        });

        $(window).one('scroll', function () {
            var $productGrid = $('.search-results.redesign-plp .product-grid');
            if ($productGrid.length && $productGrid.attr('data-gtm')) {
                var listingViwedData = JSON.parse($productGrid.attr('data-gtm'));
                if (Array.isArray(listingViwedData) && listingViwedData.length > 1) {
                    listingViwedData.forEach(function (element, index) {
                        if (index > 0) {
                            setTimeout(function () {
                                dataLayer.push(element);
                            }, 1000 * (index + 1));
                        }
                    });
                }
            }
        });
    },
    storefront: function () {
        $(window).scroll(promotionViewed);
        promotionViewed();
        $('[data-row-index][data-row-position][data-block-index][data-block-position]').on('click', function () {
            var el = $(this);
            var promotionId = el.data('promotionID');
            if (promotionId) {
                var promotions = [{
                    promotionID: promotionId,
                    promotionPosition: el.data('promotionPosition'),
                    promotionCreative: el.data('promotionCreative'),
                    promotionName: el.data('promotionName')
                }];
                dataLayer.push({
                    event: 'Promotion Clicked',
                    promotions: promotions
                });
            }
        });
    },
    wishlist: function () { },
    // events that should happen on every page
    all: function () {
        $('body').on('login:LegacyAccActivation', function (e, page) {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'Legacy to Player Upgrade',
                    eventLabel: page
                },
                event: 'Power Up Rewards'
            });
        });
        $('body').on('purlanding:playerDataUpload', function () {
            selectEnrollmentStatus('Enrollment Initiated');
        });
        $('body').on('purlanding:playerFormSubmit', function () {
            selectEnrollmentStatus('Enrollment Completed');
        });
        $('body').on('purlanding:playerCreateAccount', function () {
            selectPurUserType('Player');
        });
        $('body').on('purlanding:proCreateAccount', function () {
            selectPurUserType('Pro');
        });
        $('body').on('xaa:lineOfCreditFormSubmitted', function () {
            xaaLOCFormSubmitted();
        });
        $(document).on('click', '#addtocart1_rr .pdp-link .link, #addtocart1_rr .product a img', function () {
            var position = $(this).closest('.product').data('slick-index');
            ++position;
            var listItemType = 'Certona | Add To Cart Recommendation';
            if ($(this).hasClass('link')) {
                recomProductClick($.parseJSON($(this).attr('data-gtmdata')).productInfo, position, listItemType);
            } else {
                recomProductClick($.parseJSON($(this).closest('.product').find('.pdp-link .link').attr('data-gtmdata')).productInfo, position, listItemType);
            }
        });
        $(document).on('click', '.product .quickview', function () {
            var position = $(this).closest('.product-grid-tile-wrapper').data('position');
            var pageNumber = $('.product-grid [data-page-number]').length > 0 ? $('.product-grid [data-page-number]').data('page-number') : 0;
            var pageSize = pageNumber > 0 ? $('.product-grid [data-page-size]').data('page-size') : 12;
            position += pageNumber * pageSize;
            var listItemType = $(this).closest('.product-grid-tile-wrapper').data('list-item-type');
            productClick($.parseJSON($(this).closest('.product').find('.pdp-link .link').attr('data-gtmdata')), position, listItemType);
        });
        $(document).on('click', '.recommendations-account-dashboard .product-tile', function () {
            var position = $(this).closest('.product.grid-tile.slick-slide').data('slick-index') + 1;
            var listItemType = $('.recommendation-type')[0].innerText;
            var splitStr = listItemType.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            }
            listItemType = 'Account | ' + splitStr.join(' ');
            productClick($.parseJSON($(this).closest('.product').find('.pdp-link .link').attr('data-gtmdata')), position, listItemType);
        });

        if (isAppSession === 'true') {
            $('body').on('click', '.checkout-sign-in', function () {
                var event = 'custom_link';
                var details = {
                    component: 'Signin modal',
                    detail: 'Sign In',
                    source: window.pageContext.ns
                };
                dataToReactNative(details, event);
            });

            $('body').on('click', '.checkout-create-account', function () {
                var event = 'custom_link';
                var details = {
                    component: 'Signin modal',
                    detail: 'Create Account',
                    source: window.pageContext.ns
                };
                dataToReactNative(details, event);
            });

            $('body').on('click', '.pur-add-to-cart', function (e) {
                e.preventDefault();
                // signup button check to redirect to create account screen
                if (window.pageContext.ns === 'orderconfirmation' && $(this).hasClass('create-account-redirect')) {
                    postMessageToRN('goCreateAccount');
                    return;
                }
                var event = 'add_to_cart';
                var fetchpProductDetail = $('#add-pur-pro-gtm-physical').data('gtmdata');
                var item = {
                    item_id: fetchpProductDetail.productInfo.productID,
                    item_sku: fetchpProductDetail.productInfo.sku,
                    item_name: fetchpProductDetail.productInfo.name,
                    item_category: 'Power Up Rewards',
                    item_variant: 'Pro Membership',
                    item_brand: 'GameStop',
                    price: fetchpProductDetail.price.sellingPrice,
                    quantity: 1
                };
                var details = {
                    currency: fetchpProductDetail.price.currency,
                    value: fetchpProductDetail.price.sellingPrice,
                    shipping_tier: 'digital',
                    items: item,
                    source: window.pageContext.ns
                };
                if ($('#playerUpgradeModal').hasClass('show')) {
                    var shippingTier = $('.product-option .value-tile.pro-tile.selected')[0].innerText.toLowerCase().includes('physical');
                    details.shipping_tier = shippingTier ? 'Physical' : 'Digital';
                    details.items.rewards_type = shippingTier ? 'Physical' : 'Digital';
                }

                dataToReactNative(details, event);
            });

            $('[data-target="#powerupDetailsModal"]').click(function (e) {
                e.preventDefault();
                var event = 'custom_link';
                var details = {
                    component: 'Loyalty Cross Sell',
                    details: 'Power Up Rewards Pro',
                    source: window.pageContext.ns
                };
                dataToReactNative(details, event);
            });

            $('#playerUpgradeModal .close span').click(function (e) {
                e.preventDefault();
                var event = 'custom_link';
                var details = {
                    component: 'Loyalty Cross Sell',
                    details: 'Close Modal',
                    source: window.pageContext.ns
                };
                dataToReactNative(details, event);
            });

            $('.upgrade-button').click(function () {
                var event = 'custom_link';
                var details = {
                    component: 'Loyalty Cross Sell',
                    details: 'Upgrade',
                    source: window.pageContext.ns
                };
                dataToReactNative(details, event);
            });

            // Trade In: Analytics
            $('.search-initiate-analytics, .view-saved-trade-analytics').click(function (e) {
                var event = 'custom_link';
                tradeProductData(event, 'Trade In: Search Bar', e.target.getAttribute('data-text'));
            });

            if (window.pageContext.ns === 'trade search') {
                var event = 'tradein_search_results_view';
                var detailFetched = tradeResultDetails();
                var details = {
                    tradein_result_count: detailFetched.resultsCount,
                    tradein_result_term: detailFetched.searchTermEntered
                };
                if ($('.filter-bar ul li').length) {
                    details.tradein_results_filter = 'filter applied';
                }
                dataToReactNative(details, event);
            }

            if (window.pageContext.ns === 'trade details') {
                dataToReactNative({
                    screen_name: 'Trade-in PDP',
                    screen_class: 'Trade-in'
                }, 'logScreenView');
                var productTradeObject = {};
                if ($('.trade-product-details').length) {
                    productTradeObject = $.parseJSON($('.trade-product-details').attr('data-gtmdata'));
                }
                var itemDetails = populateProductItem(productTradeObject);
                var componentTradeDetail = 'Trade In: PDP';
                tradeProductData('tradein_pdp_view', componentTradeDetail, productTradeObject.productInfo.name, itemDetails);

                $('.save-trade-link, .find-store-analytics').click(function (e) {
                    var iseventStoreLocator = '';
                    if (window.pageContext.ns === 'trade details') {
                        iseventStoreLocator = $(e.target).hasClass('find-store-redirection') ? 'tradein_pdp_storelocator' : 'tradein_add_savedtrades';
                    }

                    tradeProductData(iseventStoreLocator, componentTradeDetail, productTradeObject.productInfo.name, itemDetails);
                });
            }

            if (window.pageContext.ns === 'Trade') {
                var productSavedTradeObject = {};
                var eventSavedProduct = 'tradein_product_click';
                var component = 'Trade In: Saved Trades';

                $('.savedTradeItemCards .item-image, .savedTradeItemCards .trade-line-item-name').click(function () {
                    if ($('.savedTradeItemCards .card').length) {
                        productSavedTradeObject = $.parseJSON($(this).attr('data-gtmdata'));
                    }
                    var itemSavedDetails = populateProductItem(productSavedTradeObject);

                    tradeProductData(eventSavedProduct, component, productSavedTradeObject.productInfo.name, itemSavedDetails);
                });
            }
        }
        $(document).on('click', '.recommendations-redesign-homepage .product-tile', function () {
            if (!$('.recommendations-redesign-homepage').find('.google-recommended-products')) {
                var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
                var listItemType = $(this).closest('.recommendations-redesign-homepage').find('h3');
                listItemType = $.trim(listItemType.text());
                var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
                if ($('.collection-landing').length) {
                    listItemType = 'Collection | ' + listItemType;
                    productData.productInfo.zoneSource = 'Collection';
                } else {
                    listItemType = 'Home | ' + listItemType;
                    productData.productInfo.zoneSource = 'Home';
                }
                if ($(this).closest('.product').find('.pdp-link').length) {
                    productClick(productData, position, listItemType);
                }
            }
        });
        $(document).on('click', '#search1_rr .recommended-products-caro-redesign .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var $headingRecommVal = $('#search1_rr').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = 'Search | ' + listItemType;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
            productData.productInfo.zoneSource = 'Search';
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick(productData, position, listItemType);
            }
        });
        $(document).on('click', '.recommendations-list:not(.google-recommendation) .recommended-products-caro-redesign .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var $headingRecommVal = $('.recommendations-list').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = 'PLP | ' + listItemType;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
            productData.productInfo.zoneSource = 'PLP';
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick(productData, position, listItemType);
            }
        });
        $(document).on('click', '#product1_rr .recommended-products-caro-redesign .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var $headingRecommVal = $('#product1_rr').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = 'PDP | ' + listItemType;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
            productData.productInfo.zoneSource = 'PDP';
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick(productData, position, listItemType);
            }
        });
        $(document).on('click', '#product2_rr .recommended-products-caro-redesign .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var $headingRecommVal = $('#product2_rr').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = 'PDP | ' + listItemType;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
            productData.productInfo.zoneSource = 'PDP';
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick(productData, position, listItemType);
            }
        });
        $(document).on('click', '#account1_rr .recommended-products-caro-redesign .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var $headingRecommVal = $('#account1_rr').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = 'Account | ' + listItemType;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
            productData.productInfo.zoneSource = 'Account';
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick(productData, position, listItemType);
            }
        });
        $(document).on('click', '#nosearch1_rr .recommended-products-caro-redesign .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var $headingRecommVal = $('#nosearch1_rr').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = 'pageType-Null Search | ' + listItemType;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
            productData.productInfo.zoneSource = 'pageType-Null Search';
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick(productData, position, listItemType);
            }
        });
        $(document).on('recommendation:analytics', function (e, data) {
            var productInfoArray = [];
            var zonesource;
            var categoryPattern = new RegExp('^category[0-9]*_rr$'); // for category pages
            if (data === 'product1_rr' || data === 'product2_rr') {
                zonesource = 'PDP';
            } else if (categoryPattern.test(data)) {
                zonesource = 'PLP';
            } else if (data === 'search1_rr') {
                zonesource = 'Search';
            } else if (data === 'cart1_rr') {
                zonesource = 'Cart';
            } else if (data === 'home1_rr') {
                zonesource = 'Home';
            } else if (data === 'addtocart1_rr') {
                zonesource = 'ATC Modal';
            } else if (data === 'nosearch1_rr') {
                zonesource = 'pageType-Null Search';
            } else if (data === 'account1_rr') {
                zonesource = 'Account';
            }
            var $headingRecommVal = $('#' + data).find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = zonesource + ' | ' + listItemType;
            $('#' + data + ' .pdp-link').each(function () {
                var productData = $.parseJSON($(this).attr('data-gtmdata'));
                var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
                productData.productInfo.zoneSource = zonesource;
                productData.itemPosition = position;
                productData.itemListType = listItemType;
                productInfoArray.push(productData);
            });
            dataLayer.push({
                listing: {
                    listingResults: {
                        item: productInfoArray
                    }
                },
                event: 'Listing Viewed'
            });
        });
        $(document).on('recommendation:datalayer', function (e, data) {
            var productInfoArray = [];
            var $container = data.caro;
            var googleURLParams = data.googleURLParams;
            var source = googleURLParams.source;
            var zonePlacement = googleAIRecommendationSource(source);
            var $headingRecommVal = $container.closest('.google-recommendation').find('h3');
            var componentType = $container.closest('.google-recommendation').attr('data-component-name') || '';
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = zonePlacement.zonesource + ' | ' + listItemType + ' | ' + zonePlacement.placement;
            $container.find('.pdp-link').each(function () {
                var productData = $.parseJSON($(this).attr('data-gtmdata'));
                var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
                productData.productInfo.zoneSource = zonePlacement.zonesource;
                productData.itemPosition = position;
                productData.itemListType = listItemType;
                productInfoArray.push(productData);
            });

            if (componentType !== '') {
                dataLayer.push({
                    listing: {
                        listingResults: {
                            item: productInfoArray
                        }
                    },
                    componentType: componentType,
                    event: 'Listing Viewed'
                });
            } else {
                dataLayer.push({
                    listing: {
                        listingResults: {
                            item: productInfoArray
                        }
                    },
                    event: 'Listing Viewed'
                });
            }
        });
        $(document).on('click', '.google-recommendation .recommended-products-caro-redesign .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var source = $(this).closest('.google-recommendation').data('source');
            var zonePlacement = googleAIRecommendationSource(source);
            var $headingRecommVal = $(this).closest('.google-recommendation').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = zonePlacement.zonesource + ' | ' + listItemType + ' | ' + zonePlacement.placement;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
            productData.productInfo.zoneSource = zonePlacement.zonesource;
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick(productData, position, listItemType);
            }

            if (isAppSession === 'true' && $(this).closest('#trade').length) {
                var json = {
                    event: 'go_to_pdp',
                    data: {
                        productID: productData.productInfo.productID,
                        productName: productData.productInfo.name
                    }
                };
                postMessageToRN(JSON.stringify(json));
            }
        });
        $(document).on('click', '#recentlyViewed .recently-viewed-carousel .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var $headingRecommVal = $('#recentlyViewed').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = 'PDP | ' + listItemType;
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick($.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata')), position, listItemType);
            }
        });
        $(document).on('click', '#addtocart1_rr .recommended-products-caro--added-to-cart-modal .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var $headingRecommVal = $('#addtocart1_rr').find('h3');
            var listItemType = $.trim($headingRecommVal.text());
            listItemType = 'ATC Modal | ' + listItemType;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata'));
            productData.productInfo.zoneSource = 'ATC Modal';
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick(productData, position, listItemType);
            }
        });
        $(document).on('click', '.pd-component .product .tile-image, .pd-component .product .pdp-link', function () {
            var position = $(this).closest('.product-tile.product-detail').data('position');
            var listItemType = $(this).closest('.product-tile.product-detail').data('list-item-type');
            var curatedpromo = $(this).closest('.curated-promo-component').length;
            if ($('.collection-landing').length) {
                listItemType = 'Collection | ' + listItemType;
            } else {
                listItemType = 'Home | ' + listItemType;
            }
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick($.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata')), position, listItemType, curatedpromo);
            }
        });
        $(document).on('click', '.product-grid-wrapper .product .tile-image, .product-grid-wrapper .product .pdp-link, .product-grid-tile-wrapper .product-tile-link-block', function () {
            var position = $(this).closest('.product-grid-tile-wrapper').data('position');
            var pageNumber = $('.product-grid [data-page-number]').length > 0 ? $('.product-grid [data-page-number]').data('page-number') : 0;
            var pageSize = pageNumber > 0 ? $('.product-grid [data-page-size]').data('page-size') : 12;
            position += pageNumber * pageSize;
            var listItemType = $(this).closest('.product-grid-tile-wrapper').data('list-item-type');
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClick($.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdata')), position, listItemType);
            }
        });
        $('body').on('search:cancel', function (e, data) {
            searchSuggestionEvent(data);
        });
        $('body').on('search:suggestion', function (e, data) {
            searchSuggestionEvent(data);
        });
        $('body').on('product:syndigo', function (e, data) {
            dataLayer.push({
                eventDetails: {
                    eventAction: data.eventData,
                    eventLabel: 'Syndigo'
                },
                event: 'Video Interaction'
            });
        });
        $('body').on('promotion:promotionalClicked', function (e, data) {
            dataLayer.push({
                event: 'Banner click',
                ecommerce: {
                    promoClick: {
                        promotions: [{
                            id: data.campaignID,
                            name: data.campaignName,
                            creative: data.heading,
                            position: data.position
                        }]
                    }
                }
            });
        });
        $('body').on('promotion:bannerPromotionClicked', function (e, data) {
            dataLayer.push({
                event: 'Banner click',
                componentType: data.componentType,
                ecommerce: {
                    promoClick: {
                        promotions: [{
                            id: data.campaignID,
                            name: data.campaignName,
                            creative: data.heading,
                            position: data.position
                        }]
                    }
                }
            });
        });
        $('body').on('gifthub:Clicked', function (e, data) {
            dataLayer.push({
                event: 'Banner click',
                ecommerce: {
                    promoClick: {
                        promotions: [{
                            name: data.name,
                            creative: data.heading
                        }]
                    }
                }
            });
        });
        $('body').on('product:afterAddToCart', function (e, data) {
            setTimeout(function () {
                if (data && data.gtmData) {
                    var obj = {
                        event: 'Product Added Modal',
                        ecommerce: {
                            impressions: []
                        }
                    };
                    dataLayer.push(obj);
                }
            }, 5000);
        });
        $('body').on('product:applePayCheckout', function () {
            var product = [];
            for (var i = dataLayer.length - 1; i > 0; i--) {
                if (dataLayer && (dataLayer[i].event === 'Product Viewed')) {
                    product = dataLayer[i].product;
                    break;
                }
            }
            dataLayer.push({
                event: 'Checkout Step Encountered',
                eventDetails: {
                    checkoutStep: 4,
                    checkoutOption: 'Apple Pay'
                },
                product: product
            });
            dataLayer.push({
                step: 4,
                eventDetails: {
                    checkoutOption: 'Apple Pay'
                },
                event: 'Checkout Option Selected'
            });
        });
        $('body').on('cart:afterProductDelete', function (e, obj) {
            var uuid = obj.uuid;
            var source = obj.source;
            var qty = $('.quantity[data-uuid="' + uuid + '"]').val();
            var isPurProductGTM = $('#isPURProductItem').val();
            var warrantyData = obj && obj.warrantyData;
            if (qty || isPurProductGTM === 'true') {
                var gtmData = $('.remove-product.remove-btn[data-uuid="' + uuid + '"]').data('gtmdata');
                removeFromCart(gtmData, qty, source, warrantyData);
            }
        });
        $('body').on('click', '.choose-options-btn, .in-store-pickup', function () {
            var productSKU = $(this).data('productsku');
            dataLayer.push({
                productInfo: {
                    productSKU: productSKU,
                    redirectType: $(this).hasClass('in-store-pickup') ? 'Store pickup available' : 'Choose Variant'
                },
                event: 'PLP Redirect'
            });
        });
        $('body').on('site:navigation', function (e, data) {
            var categoryData = data.categoryData;
            var linkCat;
            if (categoryData) {
                linkCat = categoryData;
            } else {
                linkCat = 'Hamburger';
            }
            dataLayer.push({
                linkInfo: {
                    linkRegion: 'Hamburger',
                    linkCategories: linkCat,
                    linkAction: data.state === 'linkOpen' ? 'linkOpen' : 'linkClick'
                },
                event: 'Navigation Link Clicked'
            });
        });
        $('.footer-top-links, .menu-footer, .copyright, .footer-social-spacer', 'footer').find('a').on('click', function () {
            var linkRegion = 'Footer';
            var linkCategories = $(this).attr('title');
            if (!linkCategories) {
                linkCategories = $(this).find('img').attr('alt');
            }
            if (!linkCategories) {
                linkCategories = $(this).find('h3').text();
            }
            if (!linkCategories) {
                linkCategories = $(this).find('h4').text();
            }
            if (linkCategories) {
                dataLayer.push({
                    linkInfo: {
                        linkRegion: linkRegion,
                        linkCategories: linkCategories
                    },
                    event: 'Navigation Link Clicked'
                });
            }
        });
        $('.header-brand, .header-trade-ins, .header-power-up, .header-account-options, .minicart-total', 'header').find('a').on('click', function () {
            var linkRegion = 'Utility';
            var linkCategories = $(this).attr('title');
            if (!linkCategories) {
                linkCategories = $(this).find('img').attr('alt');
            }
            if (!linkCategories) {
                linkCategories = $(this).find('span').text();
            }
            if (linkCategories) {
                dataLayer.push({
                    linkInfo: {
                        linkRegion: linkRegion,
                        linkCategories: linkCategories
                    },
                    event: 'Navigation Link Clicked'
                });
            }
        });
        $('.site-search form:not(.search-trades)').on('submit', function () {
            var linkRegion = 'Utility';
            var linkCategories = $(this).find('button:submit').text();
            dataLayer.push({
                linkInfo: {
                    linkRegion: linkRegion,
                    linkCategories: linkCategories
                },
                event: 'Navigation Link Clicked'
            });
        });
        $(document).on('click', '.header-account-links a, .header-account-loyalty a, .header-account-footer a, header a', function () {
            var linkRegion = 'Utility';
            var linkCategories = $(this).attr('title');
            if (!linkCategories) {
                linkCategories = $(this).text();
            }
            if (linkCategories) {
                dataLayer.push({
                    linkInfo: {
                        linkRegion: linkRegion,
                        linkCategories: linkCategories
                    },
                    event: 'Navigation Link Clicked'
                });
            }
        });
        $('form.footer-email-signup').on('submit', function () {
            var linkRegion = 'Footer';
            if (!$(this).data('event-sent')) {
                dataLayer.push({
                    linkInfo: {
                        linkRegion: linkRegion
                    },
                    event: 'Email Subscription Completed'
                });
                $(this).data('event-sent', true);
            }
        });
        /**
         * pass custom analytics event to GTM
         * @param {string} eventCategory for eventCategory
         * @param {string} eventAction for eventAction
         * @param {string} eventLabel for eventLabel
         * @param {Object} customDimensions for customDimensions
         * @param {Object} customMetrics for customMetrics
         */
        function customAnalyticsEvent(eventCategory, eventAction, eventLabel, customDimensions, customMetrics) {
            var customDimension = {
                gtmContainerId: $('#googleTagManagerIdNew').val(),
                searchInput: customDimensions && customDimensions.searchInput,
                productSKU: customDimensions && customDimensions.productSKU,
                searchAutocompleteCategory: customDimensions && customDimensions.searchAutocompleteCategory,
                searchAutocompleteValue: customDimensions && customDimensions.searchAutocompleteValue,
                cartValue: customDimensions && customDimensions.cartValue,
                componentType: customDimensions && customDimensions.componentType,
                paymentMethod: customDimensions && customDimensions.paymentMethod,
                experienceType: customDimensions && customDimensions.experienceType,
                filterType: customDimensions && customDimensions.filterType,
                filterValue: customDimensions && customDimensions.filterValue,
                persistentSignIn: customDimensions && customDimensions.persistentSignIn,
                storeId: customDimensions && customDimensions.storeId,
                memberTier: customDimensions && customDimensions.memberTier,
                authenticationState: customDimensions && customDimensions.authenticationState,
                paymentType: customDimensions && customDimensions.paymentType,
                reviewsRating: customDimensions && customDimensions.reviewsRating,
                reviewsNumber: customDimensions && customDimensions.reviewsNumber
            };
            var customMetric = {
                orderDiscount: customMetrics && customMetrics.orderDiscount,
                eventValue: customMetrics && customMetrics.eventValue
            };
            var obj = {
                event: 'analyticsEvent',
                eventCategory: eventCategory,
                eventAction: eventAction.toLowerCase(),
                eventLabel: eventLabel.toLowerCase(),
                customDimensions: customDimension,
                customMetrics: customMetric,
                ecommerce: null
            };
            dataLayer.push(obj);
        }
        $('.footer-email-signup input[name$="_email"]').on('click', function () {
            var linkRegion = 'Footer';
            if (!$(this).data('event-sent')) {
                dataLayer.push({
                    linkInfo: {
                        linkRegion: linkRegion
                    },
                    event: 'Email Subscription Started'
                });
                customAnalyticsEvent('footer', 'form started', 'promotional emails');
                $(this).data('event-sent', true);
            }
        });
        $('body').on('footer:emailSignup', function (e, data) {
            customAnalyticsEvent('footer', data.eventAction, 'promotional emails');
        });
        $('a[href*="itunes.apple.com"]', 'footer').on('click', function () {
            customAnalyticsEvent('footer', 'footer link clicked', 'apple app store');
        });
        $('a[href*="play.google.com"]', 'footer').on('click', function () {
            customAnalyticsEvent('footer', 'footer link clicked', 'google play store');
        });
        $('a[href*="facebook.com"]', 'footer').on('click', function () {
            customAnalyticsEvent('footer', 'footer link clicked', 'connect with us - facebook');
        });
        $('a[href*="twitter.com"]', 'footer').on('click', function () {
            customAnalyticsEvent('footer', 'footer link clicked', 'connect with us - twitter');
        });
        $('a[href*="youtube.com"]', 'footer').on('click', function () {
            customAnalyticsEvent('footer', 'footer link clicked', 'connect with us - youtube');
        });
        $('a[href*="instagram.com"]', 'footer').on('click', function () {
            customAnalyticsEvent('footer', 'footer link clicked', 'connect with us - instagram');
        });
        $('.footer-top-links, .menu-footer', 'footer').find('a').on('click', function (e) {
            var eventLabel = e.target && e.target.innerText;
            var navCategory = $(this).parents('ul.menu-footer').siblings('h5').text();
            if (!eventLabel) {
                eventLabel = $(this).find('h4').text();
            }
            if (navCategory) {
                navCategory = navCategory.replace(/\s+/g, ' ').trim();
            } else {
                eventLabel = $(this).find('h4').text();
                navCategory = 'top_footer';
            }
            if (eventLabel) {
                customAnalyticsEvent('footer', 'footer link clicked', navCategory + ' - ' + eventLabel);
            }
        });
        $('body').on('site:navigation', function (e, data) {
            var categoryDetails = data.categoryDetails;
            var label;
            var eventAction;
            if (categoryDetails) {
                label = categoryDetails;
                eventAction = data.state === 'linkOpen' ? 'submenu opened' : 'navigation link clicked';
            } else {
                label = 'shop';
                eventAction = 'menu opened';
            }
            customAnalyticsEvent('navigation menu', eventAction, label);
        });
        $('.header-brand, .header-trade-ins', 'header').find('a').on('click', function () {
            var eventLabel = $(this).attr('title');
            if (!eventLabel) {
                eventLabel = $(this).find('span.tradein-block').text();
            }
            if (eventLabel) {
                customAnalyticsEvent('top navigation', 'navigation link clicked', eventLabel);
            }
        });
        $(document).on('click', '.header-power-up, .header-account-options .user, .minicart-total', function () {
            var eventLabel = $(this).find('span.minicart-label').text();
            if (eventLabel) {
                eventLabel = eventLabel.replace(/\s+/g, '');
            }
            if (!eventLabel) {
                eventLabel = $(this).find('span.powerup-block').text();
            }
            if (!eventLabel) {
                eventLabel = $(this).find('.user-message-redesign').text();
                if (eventLabel) {
                    eventLabel = eventLabel.replace(/\s+/g, ' ').trim();
                }
            }
            if (eventLabel) {
                customAnalyticsEvent('top navigation', 'navigation link clicked', eventLabel);
            }
        });
        $(document).on('click', '.header-account-options .user', function () {
            var eventLabel = $(this).find('.user-message-account').text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            if (eventLabel) {
                customAnalyticsEvent('account menu', 'menu opened', eventLabel);
            }
        });
        $(document).on('click', '.header-account-links a, .header-account-loyalty a, .header-account-footer a, .player-member-details, .user-active-points', function () {
            var eventLabel = $(this).attr('title');
            if (!eventLabel) {
                eventLabel = $(this).find('.get-rewards-heading').text();
                if (eventLabel) {
                    eventLabel = 'Upgrade to pro';
                }
            }
            if (!eventLabel) {
                eventLabel = $(this).text();
                if (eventLabel) {
                    eventLabel = eventLabel.replace(/\s+/g, ' ').trim();
                }
            }
            if (eventLabel) {
                customAnalyticsEvent('account menu', 'navigation link clicked', eventLabel);
            }
        });
        $('body').on('account:closeSideSheet', function () {
            customAnalyticsEvent('account menu', 'menu closed', 'account');
        });
        $('body').on('click', '.minicart-footer', function () {
            var cartValue = $(this).find('span.sub-total').text();
            var eventLabel = $(this).find('.btn.btn-primary').text();
            if (cartValue) {
                cartValue = cartValue.replace('$', '');
            }
            customAnalyticsEvent('minicart', 'button clicked', eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '', { cartValue: cartValue });
        });
        $('body').on('search:suggestion', function (e, data) {
            customAnalyticsEvent('search', 'search started', data.eventLabel, { searchAutocompleteCategory: data.searchCategory,
                searchAutocompleteValue: data.suggestResult,
                searchInput: data.queryData });
        });
        $('body').on('product:afterMinicartLoads', function () {
            var cartValue = $(this).find('span.sub-total').text();
            if (cartValue) {
                cartValue = cartValue.replace('$', '');
            }
            customAnalyticsEvent('minicart', 'minicart viewed', '', { cartValue: cartValue });
        });
        $('body').on('click', '.mobile-store-container .change-store', function () {
            customAnalyticsEvent('navigation menu', 'navigation link clicked', 'store search');
        });
        $('body').on('click', '.wishlist-and-trade-value', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'link clicked', 'trade value', { productSKU: productSku });
        });
        $(document).on('click', '.verify-sdd-address-pdp', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'link clicked', 'same day delivery', { productSKU: productSku });
        });
        $('body').on('product:verifyAddressViewed', function () {
            var productSku = $('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent(productSku ? 'pdp' : 'cart', 'modal viewed', 'same day delivery', { productSKU: productSku });
        });
        $('body').on('product:verifyAddressInvalid', function () {
            var productSku = $('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'modal form errored', 'same day delivery', { productSKU: productSku });
        });
        $('body').on('product:verifyAddressSubmitted', function () {
            var productSku = $('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'modal form submitted', 'same day delivery', { productSKU: productSku });
        });
        $(document).on('sdd:closeAddressModal', '#SDDStoreVerifyModal', function () {
            var productSku = $('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent(productSku ? 'pdp' : 'cart', 'modal closed', 'same day delivery', { productSKU: productSku });
        });
        $(document).on('click', 'li.product-thumbnail-carousel-item', function (e) {
            if (e.originalEvent) {
                var productSku = $('#product-detail-redesign').attr('data-pid');
                var position = $(this).index() + 1;
                customAnalyticsEvent('pdp', 'thumbnail clicked', 'image:' + position, { productSKU: productSku });
            }
        });
        $(document).on('change product:warrantyOptionUpdate', '#primary-details-row .warranty-option', function () {
            var check = $(this).prop('checked');
            var warranty = $(this).attr('data-display-value');
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', check ? 'warranty added' : 'warranty removed', warranty, { productSKU: productSku });
        });
        $('#product-detail-redesign .selected-store-details .store-unavailable-message, #product-detail-redesign .selected-store-details .store-address-and-link').on('click', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'link clicked', 'store search', { productSKU: productSku });
        });
        $('body').on('minicart:afterProductDelete', function (e, obj) {
            var qty = obj.qty;
            var isPurProductGTM = $('#isPURProductItem').val();
            var warrantyData = obj && obj.miniCartWarrantyObj;
            if (qty || isPurProductGTM === 'true') {
                var gtmData = obj.miniCartGTMData;
                removeFromMiniCart(gtmData, qty, warrantyData, obj.miniCartSubTotal, 'minicart');
            }
        });
        $('body').on('click', '.nav-link.faq-redesign', function () {
            customAnalyticsEvent('navigation menu', 'navigation link clicked', 'Help');
        });
        $(document).on('click', '.product-accordion-button', function (e) {
            if (e.originalEvent) {
                var eventLabel = $(this).text();
                eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
                var action = $(this).attr('aria-expanded');
                var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
                customAnalyticsEvent('pdp', action === 'true' ? 'expanded section' : 'collapsed section', eventLabel, { productSKU: productSku });
            }
        });
        $('body').on('giftCard:expandableInformation', function (e, data) {
            if (data) {
                customAnalyticsEvent('pdp', data.eventAction, data.eventLabel, { productSKU: data.productSKU });
            }
        });
        $(document).on('click', '.product-info-row .js-button-readmore', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'expanded section', 'product description', { productSKU: productSku });
        });
        $(document).on('click', '.product-info-row .js-button-readless', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'collapsed section', 'product description', { productSKU: productSku });
        });
        $(document).on('click', '.promotions-redesign .btn-show-more-promotions', function () {
            var eventValue = $(this).text();
            eventValue = eventValue ? eventValue.replace(/\D/g, '') : '';
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'link clicked', 'view promotions', { productSKU: productSku }, { eventValue: eventValue });
        });
        $(document).on('click', '.promotions-redesign .btn-show-less-promotions', function () {
            var eventLabel = $(this).text();
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'link clicked', eventLabel, { productSKU: productSku });
        });
        $(document).on('click', '.product-options-container .product-option-details, #pdp-open-flexpay-modal', function () {
            var eventLabel = $(this).attr('data-tracking-label');
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'link clicked', 'learn more - ' + eventLabel, { productSKU: productSku });
        });
        $(document).on('click', '.product-additional-messages .product-custom-messages', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('pdp', 'link clicked', 'learn more - pre-owned guarantee', { productSKU: productSku });
        });
        $('body').on('pdp:storeSearchViewed', function () {
            var productSku = $('#product-detail-redesign').attr('data-pid');
            if (productSku) {
                customAnalyticsEvent('pdp', 'modal viewed', 'store search', { productSKU: productSku });
            }
        });
        $(document).on('click submit', '.btn-outline-primary.select-store', function () {
            var productSku = $('#product-detail-redesign').attr('data-pid');
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent(productSku ? 'pdp' : 'cart', 'modal button clicked', eventLabel, { productSKU: productSku });
        });
        $('body').on('pdp:inStoreInventoryModalClose', function () {
            var productSku = $('#product-detail-redesign').attr('data-pid');
            if (productSku) {
                customAnalyticsEvent('pdp', 'modal closed', 'store search', { productSKU: productSku });
            }
        });
        $('body').on('product:trackVariantChange', function (e, data) {
            if (data && data.action) {
                customAnalyticsEvent('pdp', 'variant selected', data.action + ' - ' + data.label, { productSKU: data.productSKU });
            }
        });
        $('body').on('giftCard:trackVariantChange', function (e, data) {
            if (data) {
                customAnalyticsEvent('pdp', 'variant selected', data.action + ' - ' + data.label, { productSKU: data.productSKU });
            }
        });
        $(document).on('click', '#product-questions-accordion .show-all-link, .view-all-answers-link, #product-reviews-accordion .show-all-link', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('pdp', 'link clicked', eventLabel, { productSKU: productSku });
        });
        $(document).on('click', '#product-questions-accordion .ask-question-link, #product-reviews-accordion .write-review-link', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('pdp', 'button clicked', eventLabel, { productSKU: productSku });
        });
        $('body').on('pdp:questionAnswers', function (e, data) {
            if (data && data.pid) {
                customAnalyticsEvent('pdp', 'form submitted', data.label, { productSKU: data.pid });
            }
        });
        $('body').on('pdp:askQuestionClose', function (e, data) {
            if (data && data.pid) {
                customAnalyticsEvent('pdp', 'form closed', 'Ask a Question', { productSKU: data.pid });
            }
        });
        $('body').on('pdp:answerTheQuestion', function (e, data) {
            if (data && data.pid) {
                customAnalyticsEvent('pdp', 'form closed', 'answer the question', { productSKU: data.pid });
            }
        });
        $('body').on('pdp:writeReview', function (e, data) {
            if (data && data.pid) {
                customAnalyticsEvent('pdp', 'modal form submitted', 'Write a Review', { productSKU: data.pid });
            }
        });
        $('body').on('pdp:writeReviewExit', function (e, data) {
            if (data && data.pid) {
                customAnalyticsEvent('pdp', 'modal form closed', 'Write a Review', { productSKU: data.pid });
            }
        });
        $('body').on('pdp:reviewsSort', function (e, data) {
            if (data && data.pid) {
                customAnalyticsEvent('pdp', 'reviews sorted', data.selectedText, { productSKU: data.pid });
            }
        });
        $('body').on('pdp:reviewsFilter', function (e, data) {
            if (data && data.pid) {
                customAnalyticsEvent('pdp', 'reviews filtered', data.filterText, { productSKU: data.pid });
            }
        });
        $('body').on('pdp:qaReviewInteraction', function (e, data) {
            customAnalyticsEvent('pdp', data.eventAction, data.label, { productSKU: data.pid });
        });
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (response && response.data && response.data.gtmDetail && response.container && !response.container.hasClass('product-tile')) {
                var sku = response.data.gtmDetail.id;
                var eventSent = false;
                dataLayer.forEach(function (el) {
                    if (el.event === 'analyticsEvent' && el.eventAction === 'product detail viewed' && el.eventCategory === 'ecommerce' && el.ecommerce.detail.products[0]) {
                        eventSent = el.ecommerce.detail.products[0].id === sku;
                    }
                });
                var customObj = {
                    reviewsRating: $('#ratings-summary .bv_avgRating_component_container').text() || '0',
                    reviewsNumber: $('#ratings-summary .bv_numReviews_text').text().replace(/[()]/g, '') || '0',
                    id: response.data.gtmDetail.id
                };
                var customDimension = populateProductCustomDimension(customObj, response.experienceType);
                if (!eventSent) {
                    var productObj = response.data.gtmDetail;
                    productObj.quantity = response.data.gtmDetail.quantity;
                    var productViewedObj = {
                        ecommerce: {
                            detail: {
                                products: [productObj]
                            }
                        },
                        event: 'analyticsEvent',
                        eventCategory: 'ecommerce',
                        eventAction: 'product detail viewed',
                        eventLabel: response.data.gtmProductAvailability,
                        customDimensions: customDimension,
                        customMetrics: populateProductCustomMetrics(response.data.gtmDetail)
                    };
                    dataLayer.push(productViewedObj);
                }
            }
        });
        $('body').on('product:afterAddToCartDetails', function (e, response) {
            var productData;
            var data = response.data;
            // Check warranty selection. If selected trigger analytics event for added warranty
            var warrantySelected = [];
            var warrantyInfo;

            $('.product-option input:checked').each(function () {
                warrantySelected.push($(this));
            });

            // populate warranty related info if warranty is added
            if (warrantySelected && warrantySelected.length > 0 && data.gtmDetail && data.gtmDetail.dimension18) {
                warrantyInfo = {
                    brand: '',
                    quantity: 1,
                    variant: '',
                    dimension13: '',
                    dimension14: '',
                    dimension15: '',
                    dimension16: '',
                    dimension17: '',
                    dimension19: data.gtmDetail.id
                };

                var productId = data.gtmDetail.id;

                for (var i = data.cart.items.length - 1; i >= 0; i--) {
                    var item = data.cart.items[i];
                    if (item.id === productId) {
                        for (var j = 0; j < item.options.length; j++) {
                            var warranty = item.options[j];
                            var id = warranty.selectedValueId;
                            for (var k = 0; k < warrantySelected.length; k++) {
                                if (id === warrantySelected[k].attr('data-value-id')) {
                                    warrantyInfo.id = id;
                                    warrantyInfo.category = warranty.optionId;
                                    warrantyInfo.name = warranty.selectedValueDisplayName;
                                }
                            }
                        }
                        // set warranty price
                        if (item.productProtection && item.productProtection.selectedProtection && item.productProtection.selectedProtection.price) {
                            var warrentyPrice = item.productProtection.selectedProtection.price;
                            warrantyInfo.price = warrentyPrice.replace('$', '');
                        }
                        break;
                    }
                }
            }

            productData = [data.gtmDetail];
            if (warrantyInfo) {
                productData.push(warrantyInfo);
            }

            var customDimension;
            if ($('.pur-landing-page').length || $('#container-pur-redesign').length) {
                var customerGroups = getCookie($('#customerGroupCookie').val());
                var memberTier = customerGroups.includes('PUR-Player') ? 'Player' : 'Non Member';
                var customObj = {
                    memberTier: memberTier,
                    id: data.gtmDetail ? data.gtmDetail.id : ''
                };
                customDimension = populateProductCustomDimension(customObj);
            } else {
                customDimension = populateProductCustomDimension(data.gtmDetail);
            }
            var productAddedObj = {
                ecommerce: {
                    add: {
                        products: productData
                    }
                },
                event: 'analyticsEvent',
                eventCategory: 'ecommerce',
                eventAction: 'product added',
                eventLabel: response.label,
                customDimensions: customDimension,
                customMetrics: populateProductCustomMetrics(data.gtmDetail)
            };

            if (data && productData[0]) {
                dataLayer.push(productAddedObj);
            }
        });
        $('body').on('giftCard:afterAddToCartAnalytics', function (e, response) {
            if (response.gtmDetail) {
                var customDimension = populateProductCustomDimension(response.gtmDetail);
                var productAddedObj = {
                    ecommerce: {
                        add: {
                            products: [response.gtmDetail]
                        }
                    },
                    event: 'analyticsEvent',
                    eventCategory: 'ecommerce',
                    eventAction: 'product added',
                    eventLabel: response.label,
                    customDimensions: customDimension,
                    customMetrics: populateProductCustomMetrics(response.gtmDetail)
                };
                dataLayer.push(productAddedObj);
            }
        });
        $('body').on('product:warrantyATCEvent', function (e, response) {
            if (response.warrantyData) {
                var customDimension = populateProductCustomDimension(response.warrantyData);
                var productAddedObj = {
                    ecommerce: {
                        add: {
                            products: [response.warrantyData]
                        }
                    },
                    event: 'analyticsEvent',
                    eventCategory: 'ecommerce',
                    eventAction: 'product added',
                    eventLabel: response.label,
                    customDimensions: customDimension,
                    customMetrics: populateProductCustomMetrics(response.warrantyData)
                };
                dataLayer.push(productAddedObj);
            }
        });
        $(document).on('recommendation:datalayer', function (e, data) {
            var productInfoArray = [];
            var $container = data.caro;
            var googleURLParams = data.googleURLParams;
            var source = googleURLParams.source;
            var zonePlacement = googleAIRecommendationSource(source);
            var componentType = $container.closest('.google-recommendation').attr('data-component-name') || '';
            $container.find('.pdp-link').each(function () {
                var productData = $.parseJSON($(this).attr('data-gtmdetail'));
                var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
                productData.list = zonePlacement.listImpression;
                productData.position = position;
                productInfoArray.push(productData);
            });
            var searchQueryData = {};
            if (source === 'PLP' || source === 'SEARCH') {
                var isCategorySearch = $('#isCategorySearch');
                var isCategorySearchResult = isCategorySearch.val() === 'true' && isCategorySearch.attr('data-is-search-param') === 'false';
                searchQueryData = {
                    queryData: '',
                    suggestResult: '',
                    eventLabel: '',
                    experienceType: ''
                };

                if (!isCategorySearchResult) {
                    if (sessionStorage.getItem('searchQueryData')) {
                        searchQueryData = JSON.parse(sessionStorage.getItem('searchQueryData'));
                    }
                }
            }
            var dataObj = {
                id: $('#product-detail-redesign') && $('#product-detail-redesign').attr('data-pid'),
                componentType: componentType,
                searchInput: searchQueryData.queryData,
                searchAutocompleteValue: searchQueryData.suggestResult,
                experienceType: searchQueryData.experienceType
            };
            var customDimension = populateProductCustomDimension(dataObj);
            dataLayer.push({
                eventCategory: 'ecommerce',
                eventAction: 'product list viewed',
                eventLabel: 'recs',
                ecommerce: {
                    impressions: productInfoArray
                },
                event: 'analyticsEvent',
                customDimensions: customDimension,
                customMetrics: populateProductCustomMetrics(dataObj)
            });
        });
        $(document).on('pdp:listingViewed', function () {
            var productInfoArray = [];
            var container = $(this).find('.recently-viewed-carousel');
            container.find('.pdp-link').each(function () {
                var productData = $.parseJSON($(this).attr('data-gtmdetail'));
                var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
                productData.list = 'pdp:recently_viewed';
                productData.position = position;
                productInfoArray.push(productData);
            });
            var data = {
                id: $('#product-detail-redesign') && $('#product-detail-redesign').attr('data-pid'),
                componentType: ''
            };
            var customDimension = populateProductCustomDimension(data);
            dataLayer.push({
                eventCategory: 'ecommerce',
                eventAction: 'product list viewed',
                eventLabel: 'recs',
                ecommerce: {
                    impressions: productInfoArray
                },
                event: 'analyticsEvent',
                customDimensions: customDimension,
                customMetrics: populateProductCustomMetrics(data)
            });
        });
        $(document).on('click', '.google-recommendation .recommended-products-caro-redesign .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var source = $(this).closest('.google-recommendation').data('source');
            var zonePlacement = googleAIRecommendationSource(source);
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdetail'));
            productData.position = position || 1;
            productData.list = zonePlacement.listImpression;
            var customDimension = '';
            if (source === 'PLP' || source === 'SEARCH') {
                var isCategorySearch = $('#isCategorySearch');
                var isCategorySearchResult = isCategorySearch.val() === 'true' && isCategorySearch.attr('data-is-search-param') === 'false';
                customDimension = {
                    queryData: '',
                    suggestResult: '',
                    eventLabel: '',
                    experienceType: ''
                };

                if (!isCategorySearchResult) {
                    customDimension = JSON.parse(sessionStorage.getItem('searchQueryData'));
                }
            }
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClicked(productData, zonePlacement.listImpression, 'recs', 'product clicked', customDimension);
            }
        });
        $(document).on('click', '#recentlyViewed .recently-viewed-carousel .product-tile', function () {
            var position = $(this).closest('.product.grid-tile').data('slick-index') + 1;
            var productData = $.parseJSON($(this).closest('.product').find('.pdp-link').attr('data-gtmdetail'));
            productData.position = position || 1;
            productData.list = 'pdp:recently_viewed';
            if ($(this).closest('.product').find('.pdp-link').length) {
                productClicked(productData, 'pdp:recently_viewed', 'recs', 'product clicked');
            }
        });
        $('body').on('promotion:promotionalClicked', function (e, data) {
            if (data.promoPosition) {
                var customDimension = populateProductCustomDimension(data);
                dataLayer.push({
                    event: 'analyticsEvent',
                    eventCategory: 'ecommerce',
                    eventAction: 'promotion clicked',
                    eventLabel: data.heading,
                    ecommerce: {
                        promoClick: {
                            promotions: [{
                                id: data.campaignID,
                                name: data.campaignName,
                                creative: data.heading,
                                position: data.promoPosition
                            }]
                        }
                    },
                    customDimensions: customDimension,
                    customMetrics: populateProductCustomMetrics(data)
                });
            }
        });
        $('body').on('promotion:bannerPromotionClicked', function (e, data) {
            var customDimension = populateProductCustomDimension(data);
            dataLayer.push({
                event: 'analyticsEvent',
                eventCategory: 'ecommerce',
                eventAction: 'promotion clicked',
                eventLabel: data.heading,
                ecommerce: {
                    promoClick: {
                        promotions: [{
                            id: data.id || data.campaignID,
                            name: data.productName || data.campaignName,
                            creative: data.heading,
                            position: data.promoPosition
                        }]
                    }
                },
                customDimensions: customDimension,
                customMetrics: populateProductCustomMetrics(data)
            });
        });
        $('body').on('pdp:giftCard:afterPageLoad', function (e, data) {
            var customDimension = populateProductCustomDimension(data.gtmDetail);
            var productObj = data.gtmDetail;
            productObj.quantity = data.quantity;
            dataLayer.push({
                ecommerce: {
                    detail: {
                        products: [productObj]
                    }
                },
                event: 'analyticsEvent',
                eventCategory: 'ecommerce',
                eventAction: 'product detail viewed',
                eventLabel: data.gtmProductAvailability,
                customDimensions: customDimension,
                customMetrics: populateProductCustomMetrics(data.gtmDetail)
            });
        });
        $(document).on('click', '.order-confirmation-continue-shopping', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('order confirmation', 'link clicked', eventLabel);
        });
        $(document).on('click', '.confirm-details .account-dashboard-link', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('order confirmation', 'button clicked', eventLabel);
        });
        $(document).on('click', '.order-confirmation-pur-banner .player-atc-button.create-account-redirect', function () {
            customAnalyticsEvent('order confirmation', 'sign up started', 'player power up rewards');
        });
        $('body').on('confirmation:signUp', function () {
            customAnalyticsEvent('order confirmation', 'sign up completed', 'player power up rewards');
        });
        $(document).on('click', '.order-confirmation-pur-banner .upgrade-banner .upgrade-button', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('order confirmation', 'button clicked', 'pro ' + eventLabel);
        });
        $(document).on('click', '.order-confirmation-pur-banner .upgrade-banner .pur-pro-membership', function () {
            customAnalyticsEvent('order confirmation', 'modal viewed', 'power up rewards pro benefits');
        });
        $(document).on('click', '.modal-body.redesign .continue-shopping, .modal-body.redesign .view-cart-button', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('order confirmation', 'modal link clicked', eventLabel);
        });
        $('body').on('shipping:cartDetails', function (e, data) {
            customAnalyticsEvent('checkout', data.eventAction, data.eventLabel, { cartValue: data.cartValue && data.cartValue.replace(/\s+/g, '') });
        });
        $('body').on('checkout:placeOrder', function (e, data) {
            customAnalyticsEvent('checkout', 'button clicked', data.eventLabel.replace(/\s+/g, ' ').trim(), { cartValue: data.cartValue && data.cartValue.replace(/\s+/g, '') });
        });
        $('body').on('checkout:shippingFormCustomAnalytics', function (e, data) {
            var gtmDetail = $('#checkout-main').data('gtmdetail');
            if (!gtmDetail) {
                return;
            }
            dataLayer.push({
                event: 'analyticsEvent',
                eventCategory: 'ecommerce',
                eventAction: 'checkout step completed',
                eventLabel: data.eventLabel,
                ecommerce: {
                    checkout: {
                        actionField: {
                            step: 3,
                            option: data.option
                        },
                        products: gtmDetail.product
                    }
                },
                customDimensions: populateProductCustomDimension(gtmDetail.customDimensions),
                customMetrics: populateProductCustomMetrics(gtmDetail.customDimensions)
            });
        });
        $('body').on('checkout:updateShippingOptionAnalytics', function (e, data) {
            var gtmDetail = $('#checkout-main').data('gtmdetail');
            if (!gtmDetail) {
                return;
            }
            dataLayer.push({
                event: 'analyticsEvent',
                eventCategory: 'ecommerce',
                eventAction: 'checkout option selected',
                eventLabel: data.eventLabel,
                ecommerce: {
                    checkout_option: {
                        actionField: {
                            step: 3,
                            option: data.option
                        }
                    }
                },
                customDimensions: populateProductCustomDimension(gtmDetail.customDimensions),
                customMetrics: populateProductCustomMetrics(gtmDetail.customDimensions)
            });
        });
        $('body').on('checkout:checkoutPaymentOptionAnalytics', function (e, data) {
            var gtmDetail = $('#checkout-main').data('gtmdetail');
            if (!gtmDetail) {
                return;
            }
            var ecommerce;
            var eventAction;
            if (data.ecomAction === 'checkout_option') {
                eventAction = 'checkout option selected';
                ecommerce = {
                    checkout_option: {
                        actionField: {
                            step: 4,
                            option: data.option
                        }
                    }
                };
            } else if (data.ecomAction === 'checkout') {
                eventAction = 'checkout step completed';
                ecommerce = {
                    checkout: {
                        actionField: {
                            step: 4,
                            option: data.option
                        },
                        products: gtmDetail.product
                    }
                };
            }
            dataLayer.push({
                event: 'analyticsEvent',
                eventCategory: 'ecommerce',
                eventAction: eventAction,
                eventLabel: 'payment',
                ecommerce: ecommerce,
                customDimensions: populateProductCustomDimension({ miniCartSubTotal: data.cartValue && data.cartValue.replace(/\s+/g, '') }),
                customMetrics: populateProductCustomMetrics(gtmDetail.product)
            });
        });
        $('body').on('checkout:sddAnalytics', function (e, data) {
            customAnalyticsEvent('checkout', data.eventAction, data.eventLabel, { cartValue: data.cartValue });
        });
        $('body').on('checkout:editShippingDetailsAnalytics', function (e, data) {
            customAnalyticsEvent('checkout', data.eventAction, data.eventLabel, { cartValue: data.cartValue });
        });
        $('body').on('checkout:editPaymentDetailsAnalytics', function (e, data) {
            customAnalyticsEvent('checkout', 'option selected', 'payment', { cartValue: data.cartValue, paymentMethod: data.paymentMethod });
        });
        $('body').on('checkout:editBillingAddressDetails', function (e, data) {
            customAnalyticsEvent('checkout', data.eventAction, data.eventLabel, { cartValue: data.cartValue });
        });
        $('body').on('pdp:oosNotifyMeEmail', function (e, data) {
            customAnalyticsEvent('email', data.eventAction, data.eventLabel, { productSKU: data.productSKU });
        });
        $(document).on('keyup', '.oos-notify-form input[name$="_email"]', function () {
            var productSku = $(this).parents('#product-detail-redesign').attr('data-pid');
            customAnalyticsEvent('email', 'start', 'oos notify me', { productSKU: productSku });
            $(document).off('keyup', '.oos-notify-form input[name$="_email"]');
        });
        $('body').on('hamburgerMenu:close', function () {
            customAnalyticsEvent('navigation menu', 'menu closed', 'shop');
        });
        $(document).on('cart:updateProductWarrantyAnalytics', function (e, obj) {
            if (obj.warrantyInfo && obj.warrantyPrice) {
                var warrantyInfo = obj.warrantyInfo;
                var ecommerce;
                var warrantyData = {
                    id: warrantyInfo.sku,
                    name: warrantyInfo.name,
                    price: obj.warrantyPrice && obj.warrantyPrice.replace('$', ''),
                    quantity: 1,
                    variant: '',
                    brand: '',
                    category: '',
                    dimension13: '',
                    dimension14: '',
                    dimension15: '',
                    dimension16: '',
                    dimension17: '',
                    dimension19: obj.dimension19
                };
                if (obj.eventAction === 'product added') {
                    ecommerce = {
                        add: {
                            products: warrantyData
                        }
                    };
                } else {
                    ecommerce = {
                        remove: {
                            products: warrantyData
                        }
                    };
                }
                dataLayer.push({
                    ecommerce: ecommerce,
                    event: 'analyticsEvent',
                    eventCategory: 'ecommerce',
                    eventAction: obj.eventAction,
                    eventLabel: 'cart - warranty',
                    customDimensions: populateProductCustomDimension({}),
                    customMetrics: populateProductCustomMetrics(obj.warrantyInfo)
                });
            }
        });
        $('body').on('cart:afterUpdateQuantity', function (e, obj) {
            if (obj.data && obj.data.gtmDetail) {
                var qty = obj.qty;
                var gtmDetail = obj.data.gtmDetail;
                var warrantyInfo = obj.warrantyInfo;
                var productData;
                var ecommerce;
                var $subtotalAfterDiscount = $('.cart-order-summary .subtotal-after-discount');
                var cartValue = $subtotalAfterDiscount.length ? $subtotalAfterDiscount.text() : $('.cart-order-summary .cart-subtotal').text();
                if (cartValue) cartValue = cartValue.replace(/\s+/g, '');
                if (qty && qty.oldQuantity !== qty.newQuantity) {
                    var eventAction;
                    var quantity;
                    if (qty.oldQuantity > qty.newQuantity) {
                        eventAction = 'product removed';
                        quantity = qty.oldQuantity - qty.newQuantity;
                    } else {
                        eventAction = 'product added';
                        quantity = qty.newQuantity - qty.oldQuantity;
                    }
                    gtmDetail.quantity = quantity;
                    if (warrantyInfo) {
                        gtmDetail.dimension18 = warrantyInfo.id;
                        productData = [gtmDetail];
                        warrantyInfo.quantity = quantity;
                        productData.push(warrantyInfo);
                    } else {
                        productData = [gtmDetail];
                    }
                    if (eventAction === 'product added') {
                        ecommerce = {
                            add: {
                                products: productData
                            }
                        };
                    } else {
                        ecommerce = {
                            remove: {
                                products: productData
                            }
                        };
                    }
                    dataLayer.push({
                        ecommerce: ecommerce,
                        event: 'analyticsEvent',
                        eventCategory: 'ecommerce',
                        eventAction: eventAction,
                        eventLabel: 'cart - change quantity',
                        customDimensions: populateProductCustomDimension({ miniCartSubTotal: cartValue && cartValue.replace('$', '') }),
                        customMetrics: populateProductCustomMetrics(gtmDetail)
                    });
                }
            }
        });
        $('body').on('cart:removeFromCartAnalytics', function (e, obj) {
            var uuid = obj.uuid;
            var $subtotalAfterDiscount = $('.cart-order-summary .subtotal-after-discount');
            var cartValue = $subtotalAfterDiscount.length ? $subtotalAfterDiscount.text() : $('.cart-order-summary .cart-subtotal').text();
            if (cartValue) cartValue = cartValue.replace(/\s+/g, '');
            var qty = $('.quantity[data-uuid="' + uuid + '"]').val();
            var isPurProductGTM = $('#isPURProductItem').val();
            var warrantyData = obj && obj.warrantyData;
            if (qty || isPurProductGTM === 'true' || $('#purBonusProduct').length) {
                var gtmDetail = $('.remove-product.remove-btn[data-uuid="' + uuid + '"]').data('gtmdetail');
                removeFromMiniCart(gtmDetail, qty || '1', warrantyData, cartValue && cartValue.replace('$', ''), 'cart - change quantity');
            }
        });
        $('body').on('cart:verifyAddressInvalid', function () {
            customAnalyticsEvent('cart', 'modal form errored', 'same day delivery');
        });
        $('body').on('cart:verifyAddressSubmitted', function () {
            customAnalyticsEvent('cart', 'modal form submitted', 'same day delivery');
        });
        $('body').on('cart:storeSearchViewed', function () {
            customAnalyticsEvent('cart', 'modal viewed', 'store search');
        });
        $('body').on('cart:inStoreInventoryModalClose', function () {
            customAnalyticsEvent('cart', 'modal closed', 'store search');
        });
        $(document).on('click', '.phone-number-container .help-phone-number', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('cart', 'phone number clicked', eventLabel);
        });
        $('.checkout-and-applepay .checkout-btn').on('click', function () {
            customAnalyticsEvent('cart', 'button clicked', 'proceed to checkout');
        });
        $(document).on('cart-paypal-checkout:start', function () {
            customAnalyticsEvent('cart', 'button clicked', 'proceed to paypal');
        });
        $(document).on('cart-promo-applied:error', function (e, code) {
            customAnalyticsEvent('cart', 'promo code errored', code);
        });
        $(document).on('cart-promo-applied:success', function (e, code) {
            customAnalyticsEvent('cart', 'promo code applied', code);
        });
        $(document).on('change', '.delivery-options-pid .delivery-option', function () {
            var deliveryOption = $(this).val();
            var selectedDeliveryOption;
            var gtmDetail = $(this).parents('.card.product-info').find('.remove-btn.remove-product.remove-line-hyperlink').data('gtmdetail');
            if (deliveryOption === 'home') {
                selectedDeliveryOption = 'Deliver To Home';
            } else if (deliveryOption === 'store') {
                var $storeTitle = $('.can-pickup.vertical .font-bold .pickup-label');
                var $availableTitle = $('.can-pickup.vertical .font-bold .available-tomorrow');
                $availableTitle = $availableTitle.length ? $availableTitle.text().replace(/\s+/g, ' ').trim() : $('.can-pickup.vertical .font-bold .available-today').text().replace(/\s+/g, ' ').trim();
                selectedDeliveryOption = $storeTitle.length ? $storeTitle.text().replace(/\s+/g, ' ').trim() + ' ' + $availableTitle : '';
            } else if (deliveryOption === 'sdd') {
                var $sddTitle = $('.delivery-options-card .same-day-title');
                selectedDeliveryOption = $sddTitle.length ? $sddTitle.text().replace(/\s+/g, ' ').trim() : '';
            }
            if (selectedDeliveryOption && gtmDetail) {
                dataLayer.push({
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: 1,
                                option: selectedDeliveryOption
                            },
                            products: [gtmDetail]
                        }
                    },
                    event: 'analyticsEvent',
                    eventCategory: 'ecommerce',
                    eventAction: 'cart option selected',
                    eventLabel: 'shipping',
                    customDimensions: populateProductCustomDimension(gtmDetail),
                    customMetrics: populateProductCustomMetrics(gtmDetail)
                });
            }
        });
        $(document).on('click', '.pro-upsell-container .join-btn.js-pur-upgrade', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('cart', 'button clicked', eventLabel);
        });
        $(document).on('click', '.protect-your-purchase-container .product-protection-modal', function () {
            customAnalyticsEvent('cart', 'link clicked', 'product replacement plan - learn more');
        });
        $('body').on('cart:saveForLaterOrMoveToCart', function (e, data) {
            customAnalyticsEvent('ecommerce', data.eventAction, 'cart - save for later', { productSKU: data.productSKU });
        });
        $('.search-results').on('click', '.refinement-bar a', function () {
            var filterValue = $(this).find('label').text();
            var filterType = $(this).parents('.card-body').siblings('.card-header').text();
            var $breadcrumbs = $('.redesign-breadcrumbs').find('li.breadcrumb-item:not(:first-child)');
            var eventLabel = '';
            $breadcrumbs.each(function (index) {
                eventLabel += $.trim($(this).find('a').text().split('\n')
                    .join(' '));
                if (index !== $breadcrumbs.length - 1) {
                    eventLabel += '/';
                }
            });
            if (!filterValue) {
                filterValue = $(this).find('span').text();
                var filterVal = $(this).parents('.card-body').siblings('.card-header').find('span');
                if (filterVal.length) {
                    filterType = filterVal.text();
                }
            }
            var customerRating = $(this).find('.grey-stars.star-img').attr('data-no-of-stars');
            var searchQueryData = {
                queryData: '',
                suggestResult: '',
                eventLabel: '',
                experienceType: ''
            };
            var isCategorySearch = $('#isCategorySearch');
            var isCategorySearchResult = isCategorySearch.val() === 'true' && isCategorySearch.attr('data-is-search-param') === 'false';

            if (!isCategorySearchResult) {
                if (sessionStorage.getItem('searchQueryData')) {
                    searchQueryData = JSON.parse(sessionStorage.getItem('searchQueryData'));
                }
            }
            if (filterValue) {
                customAnalyticsEvent(isCategorySearchResult ? 'browse' : 'search', 'product list filtered', eventLabel, { filterType: $.trim(filterType), filterValue: customerRating ? customerRating + $.trim(filterValue) : $.trim(filterValue), searchInput: searchQueryData.queryData, searchAutocompleteValue: searchQueryData.suggestResult, experienceType: searchQueryData.experienceType });
            }
        });
        $('body').on('search:sortProductListEvent', function (e, data) {
            var $breadcrumbs = $('.redesign-breadcrumbs').find('li.breadcrumb-item:not(:first-child)');
            var eventLabel = '';
            $breadcrumbs.each(function (index) {
                eventLabel += $.trim($(this).find('a').text().split('\n')
                    .join(' '));
                if (index !== $breadcrumbs.length - 1) {
                    eventLabel += '/';
                }
            });
            var searchQueryData = {
                queryData: '',
                suggestResult: '',
                eventLabel: '',
                experienceType: ''
            };
            var isCategorySearch = $('#isCategorySearch');
            var isCategorySearchResult = isCategorySearch.val() === 'true' && isCategorySearch.attr('data-is-search-param') === 'false';

            if (!isCategorySearchResult) {
                if (sessionStorage.getItem('searchQueryData')) {
                    searchQueryData = JSON.parse(sessionStorage.getItem('searchQueryData'));
                }
            }
            customAnalyticsEvent(isCategorySearchResult ? 'browse' : 'search', 'product list sorted', eventLabel, { filterType: data.filterType, filterValue: $.trim(data.filterValue), searchInput: searchQueryData.queryData, searchAutocompleteValue: searchQueryData.suggestResult, experienceType: searchQueryData.experienceType });
        });
        $('body').on('search:onLoadOfSearchResultsEvent', function (e, data) {
            customAnalyticsEvent('search', data.eventAction, data.searchQueryData.eventLabel, { searchInput: data.searchQueryData.queryData, searchAutocompleteValue: data.searchQueryData.suggestResult, experienceType: data.searchQueryData.experienceType });
        });
        $(document).on('click', '.product-grid-wrapper ', function () {
            var position = $(this).closest('.product-grid-tile-wrapper').data('position');
            var $productDetail = $(this).closest('.product-tile-link');
            var isCategorySearch = $('#isCategorySearch');
            var isCategorySearchResult = isCategorySearch.val() === 'true' && isCategorySearch.attr('data-is-search-param') === 'false';
            var listAndEventLabel = isCategorySearchResult === true ? 'browse' : 'search';
            var searchQueryData = {
                queryData: '',
                suggestResult: '',
                eventLabel: '',
                experienceType: ''
            };

            if (!isCategorySearchResult) {
                if (sessionStorage.getItem('searchQueryData')) {
                    searchQueryData = JSON.parse(sessionStorage.getItem('searchQueryData'));
                }
            }
            if ($productDetail.length) {
                var productData = $.parseJSON($productDetail.attr('data-gtmdetail'));
                productData.position = position || 1;
                productData.list = listAndEventLabel;
                productClicked(productData, listAndEventLabel, listAndEventLabel, 'product clicked', searchQueryData);
            }
        });
        $('body').on('trade:onLoadOfSearchResultsEvent', function (e, data) {
            customAnalyticsEvent('trade', 'trade in searched', '', { searchInput: data.searchInput });
        });
        $(document).on('click', '.trade-product-details .primary-details .print-trade, .trade-product-details .primary-details .find-store-analytics', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            var $productDetail = $(this).parents('.trade-product-details');
            customAnalyticsEvent('trade', 'link clicked', eventLabel, { productSKU: $productDetail.length ? $.parseJSON($productDetail.attr('data-gtmdata')).productInfo.sku : '' });
        });
        $(document).on('click', '.trade-grid-container .product .quickview', function () {
            var position = $(this).closest('.product-grid-tile-wrapper').data('position');
            var $productDetail = $(this).closest('.product').find('.pdp-link');
            if ($productDetail.length) {
                var productData = $.parseJSON($productDetail.attr('data-gtmdetail'));
                productData.position = position || 1;
                productData.list = 'trade quickview';
                var urlParameters = new URLSearchParams(window.location.search);
                productClicked(productData, 'trade quickview', 'trade quickview', 'trade product clicked', { queryData: urlParameters.get('q') });
            }
        });
        $(document).on('click', '.trade-grid-container .product .tile-body .pdp-link, .trade-grid-container .product .trade-image-analytics', function () {
            var position = $(this).closest('.product-grid-tile-wrapper').data('position');
            var $productDetail = $(this).closest('.product').find('.pdp-link');
            if ($productDetail.length) {
                var productData = $.parseJSON($productDetail.attr('data-gtmdetail'));
                productData.position = position || 1;
                productData.list = 'trade';
                var urlParameters = new URLSearchParams(window.location.search);
                productClicked(productData, 'trade', 'trade', 'trade product clicked', { queryData: urlParameters.get('q') });
            }
        });
        $(document).on('click', '#trade .cta-container', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('trade', 'button clicked', eventLabel);

            if (isAppSession === 'true' && eventLabel.toLowerCase() === 'find a store') {
                var json = {
                    event: 'find_store'
                };
                postMessageToRN(JSON.stringify(json));
            }
        });
        $('body').on('trade:onTradeInPdpPageLoad', function (e, data) {
            var productObj = data.gtmDetail && JSON.parse(data.gtmDetail);
            if (productObj) {
                productObj.quantity = 1;
                var productViewedObj = {
                    ecommerce: {
                        detail: {
                            products: [productObj]
                        }
                    },
                    event: 'analyticsEvent',
                    eventCategory: 'ecommerce',
                    eventAction: 'trade detail viewed',
                    eventLabel: 'pdp',
                    customDimensions: populateProductCustomDimension(productObj),
                    customMetrics: populateProductCustomMetrics(productObj)
                };
                dataLayer.push(productViewedObj);
            }
        });
        $(document).on('change', '.trade-product-details input[name="trade-value-condition"], .trade-quickview input[name="trade-value-condition"]', function () {
            var eventLabel = $(this).siblings('.custom-control-label').text();
            var $productDetail = $(this).parents('.trade-product-details');
            var searchInput;
            if (!$productDetail.length) {
                $productDetail = $(this).parents('.trade-quickview');
                var urlParameters = new URLSearchParams(window.location.search);
                searchInput = urlParameters.get('q');
            }
            customAnalyticsEvent('trade', 'variant selected', 'condition - ' + $.trim(eventLabel), { productSKU: $productDetail.length ? $.parseJSON($productDetail.attr('data-gtmdata')).productInfo.sku : '', searchInput: searchInput });
        });
        $('body').on('trade:quickViewShown', function (e, data) {
            var productObj = data.gtmDetail && JSON.parse(data.gtmDetail);
            if (productObj) {
                productObj.quantity = 1;
                var urlParameters = new URLSearchParams(window.location.search);
                var obj = {
                    searchInput: urlParameters.get('q'),
                    id: productObj.id
                };
                var productViewedObj = {
                    ecommerce: {
                        detail: {
                            products: [productObj]
                        }
                    },
                    event: 'analyticsEvent',
                    eventCategory: 'ecommerce',
                    eventAction: 'trade detail viewed',
                    eventLabel: 'quickview',
                    customDimensions: populateProductCustomDimension(obj),
                    customMetrics: populateProductCustomMetrics(obj)
                };
                dataLayer.push(productViewedObj);
            }
        });
        $('body').on('search:experimentationEvent', function (e, data) {
            customAnalyticsEvent('experimentation', 'experiment activated', data.eventLabel, { searchInput: data.searchQueryData.queryData, searchAutocompleteValue: data.searchQueryData.suggestResult, experienceType: data.searchQueryData.experienceType });
        });
        $('body').on('analyticsEvent:login', function (e, data) {
            customAnalyticsEvent('login', data.eventAction, '');
        });
        $('body').on('analyticsEvent:loginError', function (e, data) {
            customAnalyticsEvent('login', 'login errored', data.eventLabel && data.eventLabel.toString());
        });
        $(document).on('click touchstart', '.forgot-password-link-js, .create-account-button .create-account-btn, .not-user-text .logout-link, .create-account-initial .create-account-button, .login-guest-checkout .checkout-as-guest', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('login', 'button clicked', eventLabel);
        });
        $(document).on('click', '.dashboard-nav-link', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('account navigation', 'navigation link clicked', eventLabel);
        });
        $('.order-items-list .track-order-link').on('click', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('order details', 'button clicked', eventLabel);
            if (isAppSession === 'true') {
                dataToReactNative({
                    eventCategory: 'order details',
                    eventAction: 'button clicked',
                    eventLabel: eventLabel
                }, 'analyticsEvent');
            }
        });
        $(document).on('click', '.digital-token-summary .instructions-link, .download-instructions-analytics', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('order details', 'link clicked', eventLabel);
            if (isAppSession === 'true') {
                dataToReactNative({
                    eventAction: 'link clicked',
                    eventCategory: 'order details',
                    eventLabel: eventLabel
                }, 'analyticsEvent');
            }
        });
        $(document).on('click', '.account-dashboard-container .rewards-banner a', function () {
            promoClicked('account promo', $(this)[0].href, 'account promo', 'redeem points', 1);
        });
        $(document).on('click', '.account-dashboard-container .gameinformer-banner a', function () {
            var $position = $('.account-dashboard-container .rewards-banner');
            $position = $position.length ? 2 : 1;
            promoClicked('account promo', $(this)[0].href, 'account promo', $(this).siblings('.display-3').text().toLowerCase(), $position);
        });
        $(document).on('click', '.account-dashboard-container .customer-care-banner', function () {
            var $position = $('.account-dashboard-container .rewards-banner');
            $position = $position.length ? 3 : 2;
            var creative = $(this).find('.heading').text();
            creative = creative ? creative.replace(/\s+/g, ' ').trim().toLowerCase() : '';
            promoClicked('account promo', $(this).find('a:first').attr('href'), 'account promo', creative, $position);
        });
        $(document).on('click', '.order-items-list .card #product-image-redirection, .order-items-list .card #product-tile-link-redirection', function () {
            var $productDetail = $(this).parents('.row.product-info-row ').find('#gtmlDetail').val();
            if ($productDetail) {
                var productObject = $.parseJSON($productDetail);
                var price = $(this).parents('.row.product-info-row ').find('.price-col .sale-price').text();
                price = price ? price.replace('$', '').trim() : '';
                if (price) { productObject.price = price; }
                dataLayer.push({
                    event: 'analyticsEvent',
                    eventCategory: 'ecommerce',
                    eventAction: 'product clicked',
                    eventLabel: 'order details',
                    ecommerce: {
                        impressions: [productObject]
                    },
                    customDimensions: populateProductCustomDimension(productObject),
                    customMetrics: populateProductCustomMetrics(productObject)
                });

                if (isAppSession === 'true') {
                    dataToReactNative({
                        eventCategory: 'order details',
                        eventAction: 'product clicked',
                        eventLabel: 'product image | product link',
                        ecommerce: {
                            impressions: [productObject]
                        },
                        customDimensions: populateProductCustomDimension(productObject),
                        customMetrics: populateProductCustomMetrics(productObject)
                    }, 'analyticsEvent');
                }
            }
        });
        $(document).on('click', '#btn-submit-track-order', function () {
            var eventLabel = $(this).text();
            eventLabel = eventLabel ? eventLabel.replace(/\s+/g, ' ').trim() : '';
            customAnalyticsEvent('order', 'link clicked', eventLabel);
            if (isAppSession === 'true') {
                dataToReactNative({
                    eventCategory: 'order',
                    eventAction: 'link clicked',
                    eventLabel: eventLabel
                }, 'analyticsEvent');
            }
        });
        $('body').on('orderHistory:errorScenario', function (e, data) {
            customAnalyticsEvent('order history', 'app errored', data.eventLabel);
            if (isAppSession === 'true') {
                dataToReactNative({
                    eventCategory: 'order history',
                    eventAction: 'error encountered',
                    eventLabel: data.eventLabel
                }, 'analyticsEvent');
            }
        });
        $('body').on('profile:editLinkClicked', function (e, data) {
            customAnalyticsEvent('account profile', 'link clicked', data.eventLabel);
        });
        $('body').on('profile:saveButtonClicked', function (e, data) {
            customAnalyticsEvent('account profile', 'button clicked', 'save ' + data.eventLabel);
        });
        $('body').on('password:successfullyChanged', function () {
            customAnalyticsEvent('password', 'password changed', '');
        });
        $(document).on('click', '.address-card-body-wrapper .btn-new-address', function () {
            customAnalyticsEvent('address book', 'button clicked', 'add new address');
        });
        $(document).on('click', '.account-card .addNewCardArea .submit-redesign-btn', function () {
            customAnalyticsEvent('payments', 'button clicked', 'add new payment');
        });
        $(document).on('click', '.card.address-card.fixed-height-address-card a', function () {
            customAnalyticsEvent('address book', 'link clicked', $(this).text().trim());
        });
        $('body').on('addressOrPayment:confirmDeletion', function (e, data) {
            customAnalyticsEvent(data.eventCategory, data.eventAction, '');
        });
        $('body').on('address:saveButtonClicked', function (e, data) {
            customAnalyticsEvent('address book', data.eventAction, '');
        });
        $('body').on('addressBook:suggestedAddressModalClicked', function (e, data) {
            customAnalyticsEvent('address book', data.eventAction, data.eventLabel);
        });
        $('body').on('addressBook:modalViewedOrClosed', function (e, data) {
            customAnalyticsEvent('address book', data.eventAction, 'suggested address');
        });
        $('body').on('accountOrActivateMembership:formSubmitted', function (e, data) {
            customAnalyticsEvent('create account', 'form submitted', data.eventLabel);
        });
        $('body').on('accountOrActivateMembership:success', function (e, data) {
            customAnalyticsEvent('create account', data.eventAction, '');
        });
        $(document).on('click', '.sign-inRedesign .sign-in-link', function () {
            customAnalyticsEvent('create account', 'link clicked', $(this).text().trim());
        });
        $('body').on('login:keepMeSignedIn', function (e, data) {
            customAnalyticsEvent('login', data.eventAction, 'keep me signed in', { persistentSignIn: data.persistentSignIn });
        });
        $('body').on('password:changePasswordSteps', function (e, data) {
            customAnalyticsEvent('password', data.eventAction, data.eventLabel);
        });
        $('body').on('createAccount:radioButtonClick', function (e, data) {
            customAnalyticsEvent('create account', 'option selected', data.eventLabel);
        });
        $(document).on('click', '.store-locator-search-stores-container .storelocator-phone, .store-phone.map-phone .storelocator-phone, .storedetail-phone-analytics', function () {
            var storeId = $(this).parents('.store-details').find('.storeData').attr('data-storeid');
            if (!storeId) storeId = $(this).parents('.store-locator-detail-wrapper').attr('data-store-id');
            var eventLabel = $(this).parents('.store-details').find('h2').text();
            if (!eventLabel) eventLabel = $(this).parents('.store-locator-detail').find('.store-name-container').text();
            customAnalyticsEvent('stores', 'phone number clicked', eventLabel.trim(), { storeId: storeId });
        });
        $(document).on('click', '.store-locator-search-stores-container .my-store-link-analytics, .store-locator-company-info .my-store-link-analytics', function () {
            var storeId = $(this).parents('.store-details').find('.storeData').attr('data-storeid');
            if (!storeId) storeId = $(this).parents('.store-locator-detail-wrapper').attr('data-store-id');
            customAnalyticsEvent('stores', 'button clicked', $(this).text().trim(), { storeId: storeId });
        });
        $(document).on('click', '.store-locator-search-stores-container .store-details-link, .store-locator-search-stores-container .store-directions-link, .store-directions-analytics, .trade-value-analytics', function () {
            var storeId = $(this).parents('.store-details').find('.storeData').attr('data-storeid');
            if (!storeId) storeId = $(this).parents('.store-locator-detail-wrapper').attr('data-store-id');
            customAnalyticsEvent('stores', 'link clicked', $(this).text().trim(), { storeId: storeId });
        });
        $(document).on('click', '.store-locator-search-stores-container .store-name', function () {
            customAnalyticsEvent('stores', 'link clicked', 'store name', { storeId: $(this).parents('.store-details').find('.storeData').attr('data-storeid') });
        });
        $(document).on('click', '.map-canvas .my-store-link-analytics, .map-canvas .store-directions-link', function () {
            customAnalyticsEvent('stores', 'map link clicked', $(this).text().trim(), { storeId: $(this).parents('.store-details').find('.storeData').attr('data-storeid') });
        });
        $(document).on('click', '.map-canvas .store-name .store-map', function () {
            customAnalyticsEvent('stores', 'map link clicked', 'store name', { storeId: $(this).parents('.store-details').find('.storeData').attr('data-storeid') });
        });
        $('body').on('trade:onWizardSelectedFields', function (e, data) {
            var modalName = 'trade-' + ( $('.trade-modal-type').length ?  $('.trade-modal-type').val() : '');
            customAnalyticsEvent(modalName, 'variant selected', data.selectorfor + ' - ' + data.selectedValue);
        });
        $('body').on('trade:onWizardSelectedConditionFields', function (e, data) {
            var modalName = 'trade-' + ( $('.trade-modal-type').length ?  $('.trade-modal-type').val() : '');
            customAnalyticsEvent(modalName, 'variant selected', 'condition - ' + data.selectedConditionName);
        });
        $('body').on('trade:onWizardEstimationSuccess', function () {
            var modalName = 'trade-' + ( $('.trade-modal-type').length ?  $('.trade-modal-type').val() : '');
            customAnalyticsEvent(modalName, 'trade-in estimated', '');
        });
        $('body').on('click', '.trade-email-submit', function () {
            var modalName = 'trade-' + ( $('.trade-modal-type').length ?  $('.trade-modal-type').val() : '');
            customAnalyticsEvent(modalName, 'button clicked', $(this).text().trim());
        });
        $('body').on('click', '.another-trade-link ', function () {
            var modalName = 'trade-' + ( $('.trade-modal-type').length ?  $('.trade-modal-type').val() : '');
            customAnalyticsEvent(modalName, 'button clicked', $(this).text().trim());
        });
        $(document).on('click', '.giftcard-redemption-container #gift-show', function () {
            var $subtotalAfterDiscount = $('.subtotal-after-discount');
            var cartValue = $subtotalAfterDiscount.length ? $subtotalAfterDiscount.text() : $('.cart-subtotal').text();
            if (cartValue) cartValue = cartValue.replace(/\s+/g, '');
            customAnalyticsEvent('checkout', 'link clicked', $(this).text().trim(), { cartValue: cartValue ? cartValue.replace('$', '') : '' });
        });
        $(document).on('click', '.sticky-banner-container .btn.join-btn.js-pur-upgrade, .pur-cta-container .btn.join-btn.js-pur-upgrade', function () {
            var customerGroups = getCookie($('#customerGroupCookie').val());
            var memberTier = customerGroups.includes('PUR-Player') ? 'Player' : 'Non Member';
            customAnalyticsEvent('power up rewards', 'button clicked', 'go pro now', { memberTier: memberTier });
        });


        $('a[href*="itunes.apple.com"]', 'footer').on('click', function () {
            dataLayer.push({
                eventDetails: {
                    downloadType: 'app store'
                },
                event: 'Application Downloaded'
            });
        });
        $('a[href*="play.google.com"]', 'footer').on('click', function () {
            dataLayer.push({
                eventDetails: {
                    downloadType: 'google play'
                },
                event: 'Application Downloaded'
            });
        });
        $('form.registration').on('register:success', function (e, data) {
            if (!data.gtmSessionData) {
                return;
            }
            dataLayer.push({
                user: {
                    userType: data.gtmSessionData.user.userType,
                    memberTier: data.gtmSessionData.user.memberTier,
                    memberSinceDate: data.gtmSessionData.user.memberSinceDate,
                    loyaltyPoints: data.gtmSessionData.user.loyaltyPoints,
                    loginStatus: data.gtmSessionData.user.loginStatus,
                    custKey: data.gtmSessionData.user.custKey,
                    lastOrderDate: data.gtmSessionData.user.lastOrderDate,
                    customerStatus: data.gtmSessionData.user.customerStatus
                },
                event: 'User Registered',
                persistentLoginFlag: data.rememberMe
            });
        });
        $('body').on('click', '.my-store-link', function (e) {
            e.preventDefault();
            var storeDetails = $(this).parents('.store-details').find('.storeData');
            var storeID = storeDetails.attr('data-storeID');
            var storeName = storeDetails.attr('data-storeName');
            var storeStateProvince = storeDetails.attr('data-stateProvince');
            var storePostalCode = storeDetails.attr('data-postalCode');
            var storeCity = storeDetails.attr('data-City');
            dataLayer.push({
                storeSearch: {
                    selectAction: 'store Select'
                },
                store: {
                    storeName: storeName,
                    storeID: storeID,
                    stateProvince: storeStateProvince,
                    postalCode: storePostalCode,
                    city: storeCity
                },
                event: 'Store Selected'
            });
        });
        $('form.step-3').on('register:success', function (e, data) {
            if (!data.gtmSessionData) {
                return;
            }
            dataLayer.push({
                user: {
                    userType: data.gtmSessionData.user.userType,
                    memberTier: data.gtmSessionData.user.memberTier,
                    memberSinceDate: data.gtmSessionData.user.memberSinceDate,
                    loyaltyPoints: data.gtmSessionData.user.loyaltyPoints,
                    loginStatus: data.gtmSessionData.user.loginStatus,
                    custKey: data.gtmSessionData.user.custKey,
                    lastOrderDate: data.gtmSessionData.user.lastOrderDate,
                    customerStatus: data.gtmSessionData.user.customerStatus
                },
                event: 'User Registered',
                persistentLoginFlag: data.rememberMe
            });
        });
        $(document).on('login:success', 'form.login', function (e, data) {
            if (!data.gtmSessionData) {
                return;
            }
            dataLayer.push({
                user: {
                    userType: data.gtmSessionData.user.userType,
                    memberTier: data.gtmSessionData.user.memberTier,
                    memberSinceDate: data.gtmSessionData.user.memberSinceDate,
                    loyaltyPoints: data.gtmSessionData.user.loyaltyPoints,
                    loginStatus: data.gtmSessionData.user.loginStatus,
                    custKey: data.gtmSessionData.user.custKey,
                    lastOrderDate: data.gtmSessionData.user.lastOrderDate,
                    customerStatus: data.gtmSessionData.user.customerStatus
                },
                event: 'User Signed In',
                persistentLoginFlag: data.rememberMe
            });
        });
        $(document).on('login:initiate', 'form.login', function (e, data) {
            if (!data.gtmSessionData) {
                return;
            }
            dataLayer.push({
                user: {
                    userType: data.gtmSessionData.user.userType,
                    memberTier: data.gtmSessionData.user.memberTier,
                    memberSinceDate: data.gtmSessionData.user.memberSinceDate,
                    loyaltyPoints: data.gtmSessionData.user.loyaltyPoints,
                    loginStatus: data.gtmSessionData.user.loginStatus,
                    custKey: data.gtmSessionData.user.custKey,
                    lastOrderDate: data.gtmSessionData.user.lastOrderDate,
                    customerStatus: data.gtmSessionData.user.customerStatus
                },
                event: 'User Sign In Initate'
            });
        });
        $('a[data-action="logout"]').on('click', function (e) {
            var el = $(this);
            var gtmSessionData = el.data('gtmdata');
            if (!gtmSessionData) {
                return;
            }
            e.preventDefault();
            var logoutUrl = el.attr('href');
            dataLayer.push({
                user: {
                    userType: gtmSessionData.user.userType,
                    memberTier: gtmSessionData.user.memberTier,
                    memberSinceDate: gtmSessionData.user.memberSinceDate,
                    loyaltyPoints: gtmSessionData.user.loyaltyPoints,
                    loginStatus: gtmSessionData.user.loginStatus,
                    custKey: gtmSessionData.user.custKey,
                    lastOrderDate: gtmSessionData.user.lastOrderDate,
                    customerStatus: gtmSessionData.user.customerStatus
                },
                event: 'User Signed Out'
            });
            window.location.href = logoutUrl;
        });
        $(document).on('storelocator:search-completed', function (e, data) {
            var searchTerm = $('#store-search-input').val();
            if (!searchTerm) {
                searchTerm = $('#store-postal-code').val();
            }

            if (!data || !searchTerm) {
                return;
            }

            var resultsCount = data.stores && data.stores.length;
            dataLayer.push({
                storeSearch: {
                    selectAction: resultsCount ? 'store search' : 'results not returned'
                },
                listing: {
                    listingResults: {
                        resultsCount: resultsCount || 0
                    },
                    listingParams: {
                        searchInfo: {
                            searchTermEntered: searchTerm
                        }
                    }
                },
                event: 'Store Searched'
            });
            var productSku = $('#product-detail-redesign').attr('data-pid');
            if (productSku) {
                customAnalyticsEvent('pdp', 'modal form submitted', 'store search', { productSKU: productSku });
            } else if ($('.cart-page').length) {
                customAnalyticsEvent('cart', 'modal form submitted', 'store search');
            } else {
                customAnalyticsEvent('stores', 'stores searched', data.radius + ' miles');
            }
        });
        $(document).on('quickview:shown', '.quickview', function () {
            var gtmData = $('.product-quickview').not('.trade-quickview').data('gtmdata');
            if (gtmData) {
                dataLayer.push({
                    product: [gtmData],
                    event: 'Product Viewed'
                });
            }
        });

        $('body').on('product:trackVariantChange', function (e, data) {
            if (data) {
                var variantChanged = {
                    event: 'PDP Variant Interaction',
                    eventDetails: {
                        eventAction: data.action,
                        eventLabel: data.label
                    },
                    productSKU: data.productSKU,
                    position: data.position
                };
                dataLayer.push(variantChanged);
            }
        });

        $('body').on('product:viewed', function (e, response) {
            var productViewedObj = {
                product: response.product,
                event: 'Product Viewed',
                certifiedRefurbished: response.isCertifiedRefurbished
            };
            dataLayer.push(productViewedObj);
        });
        $('body').on('product:afterAddressFormSubmit', function (e, response) {
            if (response.gtmData) {
                dataLayer.push({
                    product: [response.gtmData],
                    event: 'Product Viewed'
                });
            }
        });

        $('body').on('product:afterAddToCartSPA', function (e, productName) {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'SPA|Add To Cart',
                    eventLabel: 'Out Of Stock',
                    productName: productName
                },
                event: 'Site Interaction'
            });
        });

        $('body').on('product:afterAddToCart', function (e, data, curatedFlag, curatedComponentDetails) {
            var productData;
            // Check warranty selection. If selected trigger analytics event for added warranty
            var warrantySelected = [];
            var selectedWarranty;
            var warrantyComponentInfo;
            var parentProductComponentInfo;
            var warrantyName = '';
            var listNameVal = null;

            $('.product-option input:checked').each(function () {
                warrantySelected.push($(this));
            });

            // populate warranty related info if warranty is added
            if (warrantySelected && warrantySelected.length > 0 && data.gtmData && data.gtmData.productInfo.warrantyOption) {
                var warrantyInfo = {
                    zoneSource: 'PDP',
                    productType: 'Warranty',
                    parentProduct: data.gtmData.productInfo.name
                };

                var warrantyPriceInfo = {};
                var productId = data.gtmData.productInfo.sku;

                for (var i = data.cart.items.length - 1; i >= 0; i--) {
                    var item = data.cart.items[i];
                    if (item.id === productId) {
                        for (var j = 0; j < item.options.length; j++) {
                            var warranty = item.options[j];
                            var id = warranty.selectedValueId;
                            for (var k = 0; k < warrantySelected.length; k++) {
                                if (id === warrantySelected[k].attr('data-value-id')) {
                                    warrantyInfo.sku = id;
                                    warrantyInfo.productID = id;
                                    warrantyInfo.category = warranty.optionId;
                                    warrantyInfo.name = warranty.selectedValueDisplayName;
                                    warrantyName = warranty.displayName;
                                }
                            }
                        }
                        if (item.productProtection && item.productProtection.selectedProtection && item.productProtection.selectedProtection.price) {
                            var warrentyPrice = item.productProtection.selectedProtection.price;
                            warrantyPriceInfo.sellingPrice = warrentyPrice.replace('$', '');
                            warrantyPriceInfo.basePrice = warrentyPrice.replace('$', '');
                            warrantyPriceInfo.currency = 'USD';
                        }
                        break;
                    }
                }

                warrantyComponentInfo = { componentDetails: 'Warranty|' + warrantyName + '|Up-sell' };
                parentProductComponentInfo = { componentDetails: 'Warranty|' + warrantyName + '|Parent' };

                selectedWarranty = {
                    productInfo: warrantyInfo,
                    componentInfo: warrantyComponentInfo,
                    quantity: 1,
                    price: warrantyPriceInfo
                };
            }

            if (data.gtmUpsellData) {
                productData = [data.gtmData, data.gtmUpsellData];
            } else {
                productData = [data.gtmData];
                if (selectedWarranty && parentProductComponentInfo) {
                    productData.push(selectedWarranty);
                    productData[0].componentInfo = parentProductComponentInfo;
                    productData[0].productInfo.warrantyAdded = 1;
                }
                if (data.source === 'Move To Cart') {
                    productData[0].productInfo.productState = data.source;
                    productData[0].productInfo.zoneSource = 'Cart';
                }
            }

            var productAddedObj = {
                product: productData,
                event: 'Product Added'
            };

            productAddedObj = addToCartWarrantyList(productAddedObj);
            if (data.gtmData && data.gtmData.componentInfo && data.gtmData.componentInfo.componentType && data.gtmData.componentInfo.componentType === 'Recommendation') {
                listNameVal = returnListNameValue(data.gtmData.productInfo.zoneSource);
                var datacomponentName = curatedFlag ? 'Curated Promotions' : data.gtmData.componentInfo.componentName;
                productAddedObj.list = {
                    listName: listNameVal + ' | ' + datacomponentName
                };
            }
            if (curatedFlag) {
                productAddedObj.product[0].productInfo.zoneSource = returnListNameValue(data.gtmData.productInfo.zoneSource);
                productAddedObj.product[0].componentInfo = {};
                productAddedObj.product[0].componentInfo.componentDetails = curatedComponentDetails;
            }
            if (data && productData[0]) {
                dataLayer.push(productAddedObj);
            }

            if (data && data.resultval) {
                dataLayer.push({
                    productDetails: data.resultval,
                    event: 'Product Option Selected'
                });
            }
            if (data && data.gtmPURData) {
                dataLayer.push({
                    product: [data.gtmPURData],
                    event: 'Product Added'
                });
            }
        });

        $('body').on('search:updateGrid', function () {
            var label = $.trim($('.plp-pagination').find('.currentPageHighlighted').text());
            var categoryName = $('.plp-pagination').find('.cat').attr('categoryval');
            var labelVal = $('.savedata').attr('savedata');
            var labelData = labelVal === undefined || labelVal === '' ? label : labelVal.toString().concat('|' + label);
            var labelText = $.trim('1|' + labelData);
            $('.savedata').attr('savedata', labelData);
            if (label) {
                dataLayer.push({
                    pageinfo: {
                        productCagtegory: categoryName,
                        searchDepth: $.trim(labelText)
                    },
                    event: 'Pagination clicked'
                });
            }
        });
        $('body').on('cart:afterUpdateQuantity', function (e, obj) {
            if (obj.data && obj.data.gtmData) {
                var qty = obj.qty;
                var gtmData = obj.data.gtmData;
                if (qty && qty.oldQuantity !== qty.newQuantity) {
                    var eventUpdateQuabtity;
                    var quantity;
                    if (qty.oldQuantity > qty.newQuantity) {
                        eventUpdateQuabtity = 'Product Removed';
                        quantity = qty.oldQuantity - qty.newQuantity;
                    } else {
                        eventUpdateQuabtity = 'Product Added';
                        quantity = qty.newQuantity - qty.oldQuantity;
                    }
                    gtmData.quantity = quantity;
                    dataLayer.push({
                        product: [gtmData],
                        event: eventUpdateQuabtity
                    });
                }
            }
            $('body').trigger('cart:updateQuantity', { data: obj.data, qty: obj.qty });
        });
        $('body').on('trade:afterAddToSavedTrades', function (e, data) {
            var gtmData = data.gtmData;
            if (!gtmData) {
                return;
            }
            dataLayer.push(gtmData);
        });
        $('body').on('click', '.print-trade', function () {
            var gtmData = $(this).closest('.product-detail').data('gtmdata');
            if (!gtmData) {
                return;
            }
            dataLayer.push({
                productInfo: gtmData.productInfo,
                price: gtmData.price,
                event: 'Trade In Printed'
            });
        });
        $('body').on('hops:AfterRequestSubmit', function (e, data) {
            var gtmData = data.gtmData;
            if (!gtmData) {
                return;
            }
            dataLayer.push(gtmData);
        });
        $('body').on('video:expanded', function (e, data) {
            var gtmData = {
                video: data,
                event: 'Video Engaged'
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:collapsed', function (e, data) {
            var gtmData = {
                video: data,
                event: 'Video Engaged'
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:watched25Persent', function (e, data) {
            var gtmData = {
                video: data,
                event: 'Video Engaged'
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:watched50Persent', function (e, data) {
            var gtmData = {
                video: data,
                event: 'Video Engaged'
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:watched75Persent', function (e, data) {
            var gtmData = {
                video: data,
                event: 'Video Engaged'
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:watched100Persent', function (e, data) {
            var gtmData = {
                video: data,
                event: 'Video Engaged'
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:play', function (e, data) {
            var gtmData = {
                video: data,
                event: 'Video Engaged'
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:pause', function (e, data) {
            var gtmData = {
                video: data,
                event: 'Video Engaged'
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:watched25Percent', function (e, data) {
            var gtmData = {
                event: data.eventName,
                eventDetails: {
                    eventAction: 'view',
                    eventLabel: '25%'
                },
                video: data.mediainfo
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:watched50Percent', function (e, data) {
            var gtmData = {
                event: data.eventName,
                eventDetails: {
                    eventAction: 'view',
                    eventLabel: '50%'
                },
                video: data.mediainfo
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:watched75Percent', function (e, data) {
            var gtmData = {
                event: data.eventName,
                eventDetails: {
                    eventAction: 'view',
                    eventLabel: '75%'
                },
                video: data.mediainfo
            };
            dataLayer.push(gtmData);
        });
        $('body').on('video:watched100Percent', function (e, data) {
            var gtmData = {
                event: data.eventName,
                eventDetails: {
                    eventAction: 'view',
                    eventLabel: '100%'
                },
                video: data.mediainfo
            };
            dataLayer.push(gtmData);
        });
        $('body').on('ProductList:AfterUpdate', function (e, data) {
            var gtmData = data.gtmData;
            if (gtmData) {
                dataLayer.push(gtmData);
            }
        });

        $(document).on('change', '.delivery-options-pid .delivery-option', function () {
            var deliveryOption = $(this).val();
            var selectedDeliveryOption;
            if (deliveryOption === 'home') {
                selectedDeliveryOption = 'Deliver To Home';
            } else if (deliveryOption === 'store') {
                selectedDeliveryOption = 'Store Pick up';
            } else if (deliveryOption === 'delivery') {
                selectedDeliveryOption = 'Same Day Delivery';
            }
            shipmentSelected(selectedDeliveryOption);
        });

        $('.gme-v3-global-widgect a, .gme-v3-carousel-hero a').on('click', function () {
            var bannerId = $(this).data('ci-tracking');
            var bannerName = $(this).data('campaign-name');
            var widgect = $(this).hasClass('gme-v3-carousel-hero__slide') ? $(this).closest('.gme-v3-carousel-hero') : $(this).closest('.gme-v3-global-widgect');
            var creativeName = widgect.data('creative-name');
            promoClicked('promotion clicked', bannerId, bannerName, creativeName, 1);
        });

        $('body').on('home:afterPageLoad', function () {
            if ($('.home-banner').length) {
                setTimeout(function () {
                    var promoArr = [];
                    $('.home-banner').each(function (a, b) {
                        var bannerId = $(b).attr('id');
                        var bannerName = $(b).data('name');
                        promoArr.push({
                            id: bannerId,
                            name: bannerName
                        });
                    });
                    var obj = {
                        event: 'Banner Impression',
                        ecommerce: {
                            promoView: {
                                promotions: promoArr
                            }
                        }
                    };
                    dataLayer.push(obj);
                }, 2000);
            }
        });
        $('.home-banner-btn').on('click', function () {
            var banner = $(this).closest('.home-banner');
            var promoArr1 = [];
            var bannerId = $(banner).attr('id');
            var bannerName = $(banner).data('name');
            promoArr1.push({
                id: bannerId,
                name: bannerName
            });
            var obj = {
                event: 'Banner Click',
                ecommerce: {
                    promoClick: {
                        promotions: promoArr1
                    }
                }
            };
            dataLayer.push(obj);
        });
        $('.getting-started-btn').on('click', function () {
            var ppid = $(this).data('pid');
            var isxaainstore = $('#xaaInstore').data('experience');
            var modalinfo = {
                modal_category: 'Xbox All Access Modal',
                modal_label: 'Get Started | CitizenOne Financing',
                XAASteps: 'step-1 | Open a citizen one Line of credit for Xbox All access',
                metric26: '1'
            };
            if (isxaainstore) {
                modalinfo.userExperience = 'instore';
            }
            dataLayer.push({
                getStarted: {
                    productPPID: ppid
                },
                event: 'get started click'
            });
            dataLayer.push({
                modalinfo: modalinfo,
                event: 'modal popup'
            });
        });
        $('#pdp-open-flexpay-modal').on('click', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'learn more',
                    eventLabel: 'FlexPay Info viewed',
                    pageType: 'PDP'
                },
                event: 'Site Interaction'
            });
        });
        $('#cart-open-flexpay-modal').on('click', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'learn more',
                    eventLabel: 'FlexPay Info viewed',
                    pageType: 'Cart'
                },
                event: 'Site Interaction'
            });
            if (isAppSession === 'true') {
                var detail = {
                    component: 'Payment',
                    details: 'Learn more - Flexible payment',
                    source: window.pageContext.ns
                };
                dataToReactNative(detail, customLink);
            }
        });
        $('body').on('purCC:avsError', function (e, data) {
            dataLayer.push(data.analyticsData);
        });
        $('body').on('payment:placeOrderError', function (e, data) {
            dataLayer.push(
                {
                    errorDetails: {
                        errorCategory: 'ecommerce',
                        errorTrigger: data.paymentTrigger || '',
                        errorType: data.paymentType || '',
                        errorMessage: data.errorMessage || ''
                    },
                    event: 'Error Occurence'
                }
            );
        });

        $('body').on('product:giftCard:afterPageLoad', function (e, data) {
            dataLayer.push({
                product: [data],
                event: 'Product Viewed'
            });
        });

        $('label[for=giftcardtype-physical]').one('click', function () {
            var gtmData = $('.giftcard-purchase-form').data('gtmdata');
            var giftCardObj = $('.physical-giftcard');
            var productSku = giftCardObj.attr('data-physical-sku');
            var productPid = giftCardObj.attr('data-physical-pid');
            gtmData.productInfo.sku = productSku;
            gtmData.productInfo.productID = productPid;
            dataLayer.push({
                product: [gtmData],
                event: 'Product Viewed'
            });
        });

        $('body').on('product:giftCard:afterAddToCart', function (e, data) {
            dataLayer.push({
                product: [data],
                event: 'Product Added'
            });
        });

        $('body').on('header:verifyAddressInitiated', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'SDD | Header',
                    eventLabel: 'Address Verification Initiated'
                },
                event: 'ecommerce'
            });
        });

        $('body').on('header:verifyAddressSubmitted', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'SDD | Header',
                    eventLabel: 'Address Verification Submitted'
                },
                event: 'ecommerce'
            });
        });

        $('body').on('product:verifyAddressInitiated', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'SDD | PDP',
                    eventLabel: 'Address Verification Initiated'
                },
                event: 'ecommerce'
            });
        });

        $('body').on('product:verifyAddressSubmitted', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'SDD | PDP',
                    eventLabel: 'Address Verification Submitted'
                },
                event: 'ecommerce'
            });
        });

        $('body').on('cart:backButton', function () {
            var detail = {
                component: 'Navigation',
                details: 'Back Button',
                source: window.pageContext.ns
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('cart:productImageTitleClick', function () {
            var detail = {
                component: 'Navigation',
                details: 'Click to PDP',
                source: window.pageContext.ns
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('cart:protectionPlan', function (e, data) {
            var detail = {
                component: 'Product Listing',
                details: data.protectionPlan + ' : ' + data.productName,
                source: window.pageContext.ns
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('cart:deliveryOption', function (e, data) {
            var detail = {
                component: 'Product Listing',
                details: 'Fulfillment option changed to : ' + data.deliveryOption,
                source: window.pageContext.ns
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('cart:verifyAddressInitiated', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'SDD | Cart',
                    eventLabel: 'Address Verification Initiated'
                },
                event: 'ecommerce'
            });
        });

        $('body').on('cart:verifyAddressSubmitted', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'SDD | Cart',
                    eventLabel: 'Address Verification Submitted'
                },
                event: 'ecommerce'
            });
        });

        $('body').on('cart:storeSearchInitiated', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'Store Pickup | Cart',
                    eventLabel: 'Store Search Initiated'
                },
                event: 'ecommerce'
            });
        });

        $('body').on('cart:storeSelected', function (e, data) {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'Store Pickup | Cart',
                    eventLabel: 'Store Selected'
                },
                event: 'ecommerce'
            });
            if (isAppSession === 'true') {
                var json = {
                    event: 'storeChanged',
                    storeID: data ? data.storeID : ''
                };
                postMessageToRN(JSON.stringify(json));
            }
        });

        $('body').on('cart:deliveryOptionChangedToSDD', function (e, data) {
            var detail = {
                component: 'Cart Fulfillment',
                details: 'Fulfillment option changed to : ' + data.newFulfillmentMethod + ' from ' + data.oldFulfillmentMethod,
                source: window.pageContext.ns
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('cart:sddVerifyAddressInitiated', function () {
            var detail = {
                component: 'Cart SDD Address Verification',
                details: 'Cart SDD Address Verification: Initiated',
                source: window.pageContext.ns
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('cart:sddVerifyAddressCompleted', function () {
            var detail = {
                component: 'Cart SDD Address Verification',
                details: 'Cart SDD Address Verification: Completed',
                source: window.pageContext.ns
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('checkout:sddproductunavailable', function (e, data) {
            var detail = {
                component: 'Cart Checkout',
                details: 'SDD Item Unavailable:' + data.apierror,
                source: window.pageContext.ns
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('cart:updateQuantity', function (e, obj) {
            if (obj.data && obj.data.gtmData && isAppSession === 'true') {
                var gtmData = obj.data.gtmData;
                var quantity = obj.qty ? obj.qty.newQuantity : '';

                var detail = {
                    currency: gtmData.price.currency,
                    value: quantity * gtmData.price.sellingPrice,
                    quantity: quantity,
                    temp_item0: populateProductTempItem(gtmData, quantity)
                };
                dataToReactNative(detail, 'logAddToCart');
                if (window.pageContext.ns === 'cart' && !$('.cart-empty').length) {
                    postMessageOnEvent('view_cart');
                }
            }
        });

        $('.order-items-list .order-store-link').on('click', function () {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'Track Order| ' + $(this).attr('data-linkName') + ' clicked',
                    eventLabel: $(this).attr('data-storeName')
                },
                event: 'Site Interaction'
            });
        });

        $('.order-items-list .track-order-link').on('click', function () {
            var fulfillmentType = $(this).parents('.fulfillment-group').data('fulfillmenttype');
            dataLayer.push({
                eventDetails: {
                    eventAction: 'Track Order',
                    eventLabel: fulfillmentType,
                    shipmentMethod: fulfillmentType,
                    orderId: $('.order-items-list').data('orderno')
                },
                event: 'Site Interaction'
            });
        });
        $('body').on('cart-apple-pay:start', function () {
            var product = [];
            for (var i = dataLayer.length - 1; i > 0; i--) {
                if (dataLayer && (dataLayer[i].event === 'Cart Viewed' || dataLayer[i].event === 'Checkout Step Encountered')) {
                    product = dataLayer[i].product;
                    if (dataLayer[i].event === 'Checkout Step Encountered') {
                        for (var j = 0; j < product.length; j++) {
                            if (product[j].productInfo) {
                                product[j].productInfo.beginCheckout = 1;
                            }
                            if (product[j].productInfo.appliedPromotion && product[j].productInfo.appliedPromotion === 'PriceMatch') {
                                product[j].productInfo.promoLabel = 'PriceMatch';
                            }
                        }
                    }
                    break;
                }
            }
            dataLayer.push({
                event: 'Checkout Step Encountered',
                eventDetails: {
                    checkoutStep: '5b',
                    checkoutOption: 'Apple Pay'
                },
                product: product
            });
        });
        $('body').on('checkout-apple-pay:start', function () {
            var product = [];
            for (var i = dataLayer.length - 1; i > 0; i--) {
                if (dataLayer && (dataLayer[i].event === 'Checkout Step Encountered')) {
                    product = dataLayer[i].product;
                    product.forEach(function (element) {
                        element.productInfo.zoneSource = window.pageContext.ns; // eslint-disable-line no-param-reassign
                    });
                    break;
                }
            }
            dataLayer.push({
                event: 'Checkout Step Encountered',
                eventDetails: {
                    checkoutStep: 4,
                    checkoutOption: 'Apple Pay'
                },
                product: product
            });
            dataLayer.push({
                step: 4,
                eventDetails: {
                    checkoutOption: 'Apple Pay'
                },
                event: 'Checkout Option Selected'
            });
        });

        $('body').on('cart:softBundleInteraction', function (e, eventLabel) {
            dataLayer.push({
                eventDetails: {
                    eventAction: 'Soft Bundles|Cart|clicks',
                    eventLabel: eventLabel || ''
                },
                event: 'Site Interaction'
            });
        });


        $('body').on('communicationpref:emailUpdate', function (e, changedPreference) {
            var updatedValue = $(changedPreference).attr('data-value') === 'true' ? 'subscribed' : 'unsubscribed';
            var updatedLabel = $(changedPreference).closest('.preference').find('.pref-label').text();
            dataLayer.push({
                eventDetails: {
                    eventCategory: 'Email Subscriptions',
                    eventAction: updatedValue,
                    eventLabel: updatedLabel
                },
                event: 'Email Subscriptions'
            });
        });

        $('body').on('communicationpref:smsUpdate', function (e, smsValue) {
            dataLayer.push({
                eventDetails: {
                    eventCategory: 'SMS opt-in',
                    eventAction: smsValue ? 'subscribed' : 'unsubscribed'
                },
                event: 'SMS opt-in'
            });
        });

        $(document).on('communicationpref:error', function (e, errorMessage) {
            dataLayer.push({
                errorDetails: {
                    errorTrigger: 'API Error',
                    errorType: 'Customer Preferences',
                    errorMessage: errorMessage,
                    errorCategory: 'Account Pages'
                },
                event: 'Error Occurrence'
            });
        });

        $('body').on('checkout:submitShippingForm', function (e, data) {
            var gtmData = $('#checkout-main').data('gtmdata');
            if (!gtmData) {
                return;
            }
            dataLayer.push({
                event: 'Checkout Step Encountered',
                eventDetails: {
                    checkoutStep: data.checkoutStep,
                    checkoutOption: data.checkoutOption || ''
                },
                product: gtmData.product
            });
        });

        $('body').on('checkout:shippingFormAnalytics', function (e, data) {
            dataLayer.push({
                eventDetails: {
                    eventCategory: data.eventCategory,
                    eventAction: data.eventAction
                },
                event: 'Checkout Step updated'
            });
        });

        $('body').on('checkout:placeOrderButtonAnalytics', function (e, data) {
            var gtmData = $('#checkout-main').data('gtmdata');
            if (!gtmData) {
                return;
            }
            var paymentMethod;
            if (!data.checkoutOption || data.checkoutOption === 'undefined' || data.checkoutOption === 'null') {
                paymentMethod = 'NA';
            } else {
                paymentMethod = data.checkoutOption;
            }
            dataLayer.push({
                event: 'Checkout Step Encountered',
                eventDetails: {
                    checkoutStep: data.checkoutStep,
                    checkoutOption: paymentMethod
                },
                product: gtmData.product
            });
        });

        // DEN-15030 for  Single Page checkout
        $('body').on('shippingPageError:shipping', function (e, errorMessageData) {
            dataLayer.push({
                eventDetails: {
                    errorCategory: errorMessageData.errorcategory,
                    errorAction: errorMessageData.errorAction,
                    errorMessage: errorMessageData.errorMessage
                },
                event: 'Checkout Step error'
            });
        });
        $('body').on('shippingPageError:StorePickUp', function (e, errorMessageData) {
            dataLayer.push({
                eventDetails: {
                    errorCategory: errorMessageData.errorCategory,
                    errorAction: errorMessageData.errorAction,
                    errorMessage: errorMessageData.errorMessage
                },
                event: 'Checkout Step error'
            });
        });
        $('body').on('checkout:paymentError', function (e, errorMessageData) {
            dataLayer.push(
                {
                    eventDetails: {
                        errorCategory: errorMessageData.errorcategory,
                        errorAction: errorMessageData.errorAction,
                        errorMessage: errorMessageData.errorMessage
                    },
                    event: 'Checkout Step error'
                }
            );
            $(document).on('wistradeinorder:promocodeadded', function (voucherAmount) {
                dataLayer.push({
                    voucherDiscount: {
                        voucherCodeIsValid: 'true',
                        voucherType: 'tradein',
                        voucherAmount: voucherAmount
                    },
                    event: 'Promo Code Added'
                });
            });

            $(document).on('wistradeinorder:promocoderemoved', function (voucherAmt) {
                dataLayer.push({
                    voucherDiscount: {
                        voucherCodeIsValid: 'true',
                        voucherType: 'tradein',
                        voucherAmount: voucherAmt
                    },
                    event: 'Promo Code Removed'
                });
            });

            $(document).on('wistradeinorder:errors', function (errorMsg) {
                dataLayer.push({
                    eventDetails: {
                        errorCategory: 'Trade-in',
                        errorAction: 'Validation Error',
                        errorMessage: errorMsg
                    },
                    event: 'WIS Error'
                });
            });
        });

        $('body').on('checkout:paymentSectionAnalytics', function (e, data) {
            var gtmData = $('#checkout-main').data('gtmdata');
            if (!gtmData) {
                return;
            }
            if (data.checkoutStep) {
                dataLayer.push({
                    event: 'Checkout Step Encountered',
                    eventDetails: {
                        checkoutStep: data.checkoutStep,
                        checkoutOption: data.checkoutOption || ''
                    },
                    product: gtmData.product
                });
            }
            if (isAppSession === 'true') {
                if (data.action === 'save') {
                    triggerRNEvent('Payment', 'CTA: Payment | Form Saved', window.pageContext.ns, customLink);
                    postMessageOnSPC('add_payment_info', data.paymentMethod);
                }
                if (data.action === 'change') {
                    triggerRNEvent('Payment', 'Link: Change Payment | Clicked', window.pageContext.ns, customLink);
                }
            }
        });

        $('body').on('checkout:viewPaymentSection', function () {
            var isPaymentFormHidden = $('.payment-form #payment-form-body').hasClass('d-none');
            if (isPaymentElementVisible || isPaymentFormHidden) {
                return;
            }
            var $el = $('.payment-form');
            if ($el.length && 'IntersectionObserver' in window) {
                var config = {
                    rootMargin: '0px 0px 50px 0px',
                    threshold: 0
                };
                var observer = new IntersectionObserver(intersectPaymentSection, config);
                observer.observe($el[0]);
            }
        });

        $('#gc-btn-cancel').on('click', function () {
            dataLayer.push({
                eventDetails: {
                    eventCategory: 'ecommerce|Checkout',
                    eventAction: 'Payment |Cancel Click',
                    eventLabel: 'GIFT_CERTIFICATE'
                },
                event: 'Checkout Step updated'
            });
        });

        $('body').on('checkout:giftCardAppliedAmount', function (e, eventLabel) {
            dataLayer.push({
                eventDetails: {
                    eventCategory: 'ecommerce|Checkout',
                    eventAction: 'Payment|Gift Card Applied',
                    eventLabel: '$' + eventLabel
                },
                event: 'Checkout Step updated'
            });
        });

        $('body').on('cart:promoCodeSubmit', function (e, couponData) {
            var coupon = couponDetails(couponData);
            var detail = {
                component: 'Cart Coupon',
                details: 'Coupon Applied: ' + coupon.couponCode,
                source: window.pageContext.ns,
                value: coupon.value
            };
            dataToReactNative(detail, customLink);
        });

        $('body').on('checkout:editOrAddAddress', function (e, data) {
            triggerRNEvent(data.componentName, data.eventDetail, window.pageContext.ns, customLink);
        });

        $('body').on('checkout:rewardSectionAnalytics', function (e, data) {
            triggerRNEvent(data.componentName, data.eventDetail, window.pageContext.ns, customLink);
        });

        $('body').on('checkout:placeOrderAnalytics', function (e, data) {
            triggerRNEvent(data.componentName, data.eventDetail, window.pageContext.ns, customLink);
        });

        $('body').on('checkout:changeFulfillmentOption', function (e, data) {
            if (isAppSession === 'true') {
                triggerRNEvent(data.componentName, data.eventDetail, window.pageContext.ns, customLink);
            }
        });

        $('body').on('pro:pro_autorenewal', function (e, data) {
            dataLayer.push(data);
        });

        if (isAppSession === 'true') {
            $('body').on('checkout:selectPaymentSection', function (e, data) {
                postMessageOnSPC('add_payment_info', data.paymentMethod);
            });

            $('body').on('checkout:checkoutCustomErrorEventApp', function (e, data) {
                triggerRNEvent(data.component, data.eventDetail, window.pageContext.ns, customError);
            });

            $('body').on('checkout:rewardRedeemOrRemove', function (e, data) {
                var detail = {
                    component: data.componentName,
                    details: data.eventDetail,
                    value: data.value,
                    source: window.pageContext.ns
                };
                dataToReactNative(detail, customLink);
            });
        }

        if (window.pageContext.ns === 'cart') {
            $('body').on('cart:purmonthlyreward', function (e, data) {
                customAnalyticsEvent('cart', data.eventAction, data.eventLabel);
                if (isAppSession === 'true') {
                    triggerRNEvent('cart', data, window.pageContext.ns, customLink);
                }
            });

            $('body').on('cart:purreward', function (e, data) {
                customAnalyticsEvent('cart', data.eventAction, data.eventLabel);
                if (isAppSession === 'true') {
                    triggerRNEvent('cart', data, window.pageContext.ns, customLink);
                }
            });
        }
    }
};


/**
 *
 * @description Initialize the tag manager functionality
 * @param {string} nameSpace The current name space
 */
exports.init = function (nameSpace) {
    if (document.cookie.includes('notagmanager') === false) {
        var ns = nameSpace || pageContext.ns;
        if (ns && events[ns]) {
            events[ns]();
        }
        events.all();
    }
};
